(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("7C6Ys", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("7wB6S")).default; });
$parcel$export(module.exports, "envType", function () { return (parcelRequire("22Iz2")).envType; });
$parcel$export(module.exports, "userType", function () { return (parcelRequire("22Iz2")).userType; });

var $7wB6S = parcelRequire("7wB6S");

var $22Iz2 = parcelRequire("22Iz2");






});
parcelRegister("7wB6S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57a84ed5054d22d2$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $c6Xmf = parcelRequire("c6Xmf");

var $jjExS = parcelRequire("jjExS");

var $ktzPa = parcelRequire("ktzPa");

var $22Iz2 = parcelRequire("22Iz2");

var $ckDXA = parcelRequire("ckDXA");

var $awX4D = parcelRequire("awX4D");

var $fXbpq = parcelRequire("fXbpq");

var $cV8xo = parcelRequire("cV8xo");

var $hGIZ8 = parcelRequire("hGIZ8");

var $lJWVG = parcelRequire("lJWVG");

var $aHFHo = parcelRequire("aHFHo");

var $4ZR7k = parcelRequire("4ZR7k");

var $jzYVM = parcelRequire("jzYVM");

var $kTmBT = parcelRequire("kTmBT");

var $f6Y6c = parcelRequire("f6Y6c");

var $1kGnl = parcelRequire("1kGnl");

var $6f3e8 = parcelRequire("6f3e8");

var $bJ204 = parcelRequire("bJ204");

var $gnvfh = parcelRequire("gnvfh");

var $5LQZZ = parcelRequire("5LQZZ");

var $29bQh = parcelRequire("29bQh");
function $57a84ed5054d22d2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $57a84ed5054d22d2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $57a84ed5054d22d2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $57a84ed5054d22d2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $57a84ed5054d22d2$var$PROD_HOST = "as.atlassian.com/api/v1";
var $57a84ed5054d22d2$var$STARGATE_PROD_HOST = "api-private.atlassian.com/gasv3/api/v1";
var $57a84ed5054d22d2$var$STAGING_HOST = "as.staging.atl-paas.net/api/v1";
var $57a84ed5054d22d2$var$STARGATE_STAGING_HOST = "api-private.stg.atlassian.com/gasv3/api/v1";
var $57a84ed5054d22d2$var$FEDRAMP_SANDBOX_HOST = "as.atlassian-fex.com/api/v1";
var $57a84ed5054d22d2$var$STARGATE_FEDRAMP_SANDBOX_HOST = "api-private.atlassian-fex.com/gasv3/api/v1";
var $57a84ed5054d22d2$export$5df9262e102d0c32 = "/gateway/api/gasv3/api/v1";
var $57a84ed5054d22d2$var$LAST_SCREEN_EVENT_STORAGE_KEY = "last.screen.event";
var $57a84ed5054d22d2$export$2e2bcd8739ae039 = function AnalyticsWebClient(productInfo) {
    "use strict";
    var settings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _this = this;
    (0, $4GJKx._)(this, AnalyticsWebClient);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_useStargate", function(useStargate) {
        if (useStargate == null) return true;
        return useStargate;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_selectHost", function(param) {
        var useStargate = param.useStargate, env = param.env, useLegacyUrl = param.useLegacyUrl, perimeter = param.perimeter;
        if (!useStargate) {
            if (perimeter === (0, $22Iz2.perimeterType).FEDRAMP_MODERATE && env === (0, $22Iz2.envType).STAGING) return $57a84ed5054d22d2$var$FEDRAMP_SANDBOX_HOST;
            return env === (0, $22Iz2.envType).PROD ? $57a84ed5054d22d2$var$PROD_HOST : $57a84ed5054d22d2$var$STAGING_HOST;
        }
        if (useLegacyUrl) {
            if (perimeter === (0, $22Iz2.perimeterType).FEDRAMP_MODERATE && env === (0, $22Iz2.envType).STAGING) return $57a84ed5054d22d2$var$STARGATE_FEDRAMP_SANDBOX_HOST;
            return env === (0, $22Iz2.envType).PROD ? $57a84ed5054d22d2$var$STARGATE_PROD_HOST : $57a84ed5054d22d2$var$STARGATE_STAGING_HOST;
        }
        /**
       * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
       * For more details, see:
       *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
       *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
       */ return window.location.host + $57a84ed5054d22d2$export$5df9262e102d0c32;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_endsWith", function(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_changeInternalUserId", function(userId, anonymousId) {
        _this.eventProcessor.getUser().setUserId(userId);
        if (anonymousId && anonymousId !== _this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
        // Only update if it has changed.
        _this.eventProcessor.getUser().setAnonymousId(anonymousId);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_createSubproductGetter", function(subproduct) {
        return (0, $awX4D.default)(subproduct, "Cannot get subproduct from the callback. Proceeding without it.");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_createEmbeddedProductGetter", function(embeddedProduct) {
        return (0, $awX4D.default)(embeddedProduct, "Cannot get embeddedProduct from the callback. Proceeding without it.");
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getLastScreenEvent", function() {
        try {
            return JSON.parse(_this._safeSessionStorage.getItem($57a84ed5054d22d2$var$LAST_SCREEN_EVENT_STORAGE_KEY) || "");
        } catch (err) {
            _this._safeSessionStorage.removeItem($57a84ed5054d22d2$var$LAST_SCREEN_EVENT_STORAGE_KEY);
            return null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_setLastScreenEvent", function(event) {
        _this._safeSessionStorage.setItem($57a84ed5054d22d2$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
            name: event.name,
            attributes: event.attributes
        }));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_shouldEventBeDelayed", function(event) {
        // TODO: this is a temporary restriction for the purposes of the Track All Changes project
        // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
        // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
        // then we will be able to open it up for other products to use by removing this check.
        if (!event.tags || event.tags.indexOf("measurement") === -1) return false;
        var isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
        return _this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_fireEvent", function(identifier, builtEvent, context, callback) {
        switch(builtEvent.eventType){
            case (0, $22Iz2.eventType).UI:
            case (0, $22Iz2.eventType).OPERATIONAL:
            case (0, $22Iz2.eventType).TRACK:
                return _this.eventProcessor.track(identifier, builtEvent, context, callback);
            case (0, $22Iz2.eventType).SCREEN:
                return _this.eventProcessor.page(identifier, builtEvent, context, callback);
            case (0, $22Iz2.eventType).IDENTIFY:
                return _this.eventProcessor.identify(identifier, builtEvent, context, callback);
            default:
                throw new Error("No handler has been defined for events of type ".concat(builtEvent.eventType));
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_fireDelayedEvent", function(identifier, builtEvent, context, userInfo) {
        try {
            // User information can change while the delay period is active, so we need to restore the values that
            // were active when the event was originally fired.
            _this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
            builtEvent.tags = (0, $c6Xmf._)(builtEvent.tags || []).concat([
                "sentWithDelay"
            ]);
            // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
            _this._fireEvent(identifier, builtEvent, context, undefined);
        } finally{
            _this._changeInternalUserId(_this._userInfo.userId, _this._userInfo.anonymousId);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_delayEvent", function(identifier, builtEvent, context, userInfo, callback) {
        _this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
        // Fire the callback immediately, as we can consider the event successfully processed at this point
        if (callback) callback();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_processEvent", function(identifier, builtEvent, context, callback) {
        _this._testingCache.saveEvent(builtEvent);
        if (_this._shouldEventBeDelayed(builtEvent)) {
            _this._delayEvent(identifier, builtEvent, context, _this._userInfo, callback);
            return Promise.resolve();
        } else return _this._fireEvent(identifier, builtEvent, context, callback);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setEmbeddedProduct", function(embeddedProduct) {
        _this._productInfo.embeddedProduct = _this._createEmbeddedProductGetter(embeddedProduct);
        _this.resetUIViewedTimers();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearEmbeddedProduct", function() {
        _this._productInfo.embeddedProduct = _this._createEmbeddedProductGetter(null);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setSubproduct", function(subproduct) {
        _this._productInfo.subproduct = _this._createSubproductGetter(subproduct);
        _this.resetUIViewedTimers();
    });
    /**
     * Calling this function in the intialisation of the client in product
     * captures specified 'origin tracing' URL params and fires a single origin landed event
     * <p>
     * This function expects a mapping between the keys for any URL parameters
     *  that should be captured and removed for origin tracing
     * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
     * Each handler function should return an object with two items
     * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
     * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
     *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
     * </p>
     * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
     * e.g. from a share or email
     *
     * An example calling this function using an external decoding library, with taskSessionId specified to persist
     * analyticsWebClient.setOriginTracingHandlers({
          atlOrigin: encodedOrigin => {
              const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
              return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
          },
      });
     *
     * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
     * @this {AnalyticsWebClient}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setOriginTracingHandlers", function(originParamHandlerMapping) {
        var capturedOriginTraces = _this.originTracing.handleOriginParameters(originParamHandlerMapping, _this._historyReplaceFn);
        Object.keys(capturedOriginTraces).forEach(function(x) {
            if (typeof capturedOriginTraces[x].taskSessionId !== "undefined") _this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
        });
        var originAttributes = {};
        Object.keys(capturedOriginTraces).forEach(function(x) {
            if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
            else // eslint-disable-next-line no-console
            console.warn("Handling method for origin parameter ".concat(x, " has not returned any attributes"));
        });
        if (Object.keys(capturedOriginTraces).length > 0) return _this.sendOperationalEvent({
            action: "landed",
            actionSubject: "origin",
            source: "webClient",
            attributes: {
                originTracesLanded: originAttributes
            }
        }, // eslint-disable-next-line @typescript-eslint/no-empty-function
        function() {});
        return Promise.resolve();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setTenantInfo", function(tenantIdType, tenantId) {
        if (!tenantIdType) throw new Error("Missing tenantIdType");
        if (tenantIdType !== (0, $22Iz2.tenantType).NONE && !tenantId) throw new Error("Missing tenantId");
        if (!(0, $22Iz2.isType)((0, $22Iz2.tenantType), tenantIdType)) throw new Error("Invalid tenantIdType '".concat(tenantIdType, "', ") + "must be an tenantType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.tenantType)), "]"));
        _this._tenantInfo = {
            tenantIdType: tenantIdType,
            tenantId: tenantId
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearTenantInfo", function() {
        _this._tenantInfo = {};
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setOrgInfo", function(orgId) {
        if (!orgId) throw new Error("Missing orgId");
        _this._orgInfo = {
            orgId: orgId
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearOrgInfo", function() {
        _this._orgInfo = {};
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setWorkspaceInfo", function(workspaceId) {
        if (!workspaceId) throw new Error("Missing workspaceId");
        _this._workspaceInfo = {
            workspaceId: workspaceId
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearWorkspaceInfo", function() {
        _this._workspaceInfo = {};
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setUserInfo", function(userIdType, userId) {
        (0, $hGIZ8.validateIdentifyEvent)(userIdType, userId);
        _this._changeInternalUserId(userId);
        _this._userInfo = {
            userIdType: userIdType,
            userId: userId,
            anonymousId: _this.eventProcessor.getUser().getAnonymousId()
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearUserInfo", function() {
        _this._changeInternalUserId(undefined);
        _this._userInfo = {
            anonymousId: _this.eventProcessor.getUser().getAnonymousId()
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getAnonymousId", function() {
        return _this._userInfo.anonymousId;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setUIViewedAttributes", function(uiViewedAttributes) {
        if (!uiViewedAttributes) throw new Error("Missing uiViewedAttributes");
        if (typeof uiViewedAttributes !== "object" || Array.isArray(uiViewedAttributes)) throw new Error("Invalid uiViewedAttributes type, should be a non array object");
        _this._uiViewedAttributes = $57a84ed5054d22d2$var$_objectSpread({}, uiViewedAttributes);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getUIViewedAttributes", function() {
        return _this._uiViewedAttributes;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearUIViewedAttributes", function() {
        _this._uiViewedAttributes = {};
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendIdentifyEvent", function(userIdType, userId, callback) {
        _this.setUserInfo(userIdType, userId);
        var builtEvent = {
            userIdType: userIdType,
            eventType: (0, $22Iz2.eventType).IDENTIFY
        };
        return _this._processEvent(userId, builtEvent, _this._context, callback);
    });
    /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendPageEvent", function(name, callback) {
        return _this.sendScreenEvent(name, callback);
    });
    /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendScreenEvent", function(event, callback, attributes) {
        var screenName;
        var screenAttributes;
        var screenContainers;
        var screenTags;
        if (typeof event === "object") {
            /* This is for retrocompatibility */ screenName = event.name;
            screenAttributes = event.attributes;
            screenContainers = event.containers;
            screenTags = event.tags;
        } else {
            screenName = event;
            screenAttributes = attributes;
        }
        (0, $hGIZ8.validateScreenEvent)(screenName);
        (0, $hGIZ8.validateContainers)(screenContainers);
        var builtEvent = (0, $fXbpq.buildScreenEvent)(_this._productInfo, _this._tenantInfo, _this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
        event.nonPrivacySafeAttributes, screenTags, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this.task.getAllTaskSessions(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo, event, screenContainers);
        var builtEventWithName = $57a84ed5054d22d2$var$_objectSpread({
            name: screenName
        }, builtEvent);
        _this._setLastScreenEvent(builtEventWithName);
        return _this._processEvent(screenName, builtEventWithName, _this._context, (0, $5LQZZ.default)(callback, builtEventWithName));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendTrackEvent", function(event, callback) {
        (0, $hGIZ8.validateTrackEvent)(event);
        var builtEvent = (0, $fXbpq.buildActionEvent)(_this._productInfo, _this._tenantInfo, _this._userInfo, event, (0, $22Iz2.eventType).TRACK, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this.task.getAllTaskSessions(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo);
        return _this._processEvent((0, $fXbpq.buildActionName)(event), builtEvent, _this._context, (0, $5LQZZ.default)(callback, builtEvent));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendUIEvent", function(event, callback) {
        (0, $hGIZ8.validateUIEvent)(event);
        var builtEvent = (0, $fXbpq.buildActionEvent)(_this._productInfo, _this._tenantInfo, _this._userInfo, event, (0, $22Iz2.eventType).UI, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this.task.getAllTaskSessions(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo);
        return _this._processEvent((0, $fXbpq.buildActionName)(event), builtEvent, _this._context, (0, $5LQZZ.default)(callback, builtEvent));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendOperationalEvent", function(event, callback) {
        (0, $hGIZ8.validateOperationalEvent)(event);
        var builtEvent = (0, $fXbpq.buildActionEvent)(_this._productInfo, _this._tenantInfo, _this._userInfo, event, (0, $22Iz2.eventType).OPERATIONAL, _this._tabTracking.getCurrentTabId(), _this._sessionTracking.getCurrentSessionId(), _this.task.getAllTaskSessions(), _this._orgInfo, _this._pageLoadId, _this._workspaceInfo);
        return _this._processEvent((0, $fXbpq.buildActionName)(event), builtEvent, _this._context, (0, $5LQZZ.default)(callback, builtEvent));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startUIViewedEvent", function(callback) {
        _this.stopUIViewedEvent();
        _this._uiViewedEvent = new (0, $bJ204.default)(_this._productInfo, function() {
            return {
                embeddedProduct: _this._productInfo.embeddedProduct(),
                subproduct: _this._productInfo.subproduct(),
                tenantIdType: _this._tenantInfo.tenantIdType,
                tenantId: _this._tenantInfo.tenantId,
                userId: _this._userInfo.userId,
                lastScreenEvent: _this._getLastScreenEvent(),
                attributes: _this._uiViewedAttributes
            };
        }, function(event) {
            return _this.sendUIEvent(event, callback);
        });
        _this._uiViewedEvent.start();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stopUIViewedEvent", function() {
        if (_this._uiViewedEvent) {
            _this._uiViewedEvent.stop();
            _this._uiViewedEvent = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "resetUIViewedTimers", function() {
        if (_this._uiViewedEvent) _this._uiViewedEvent.resetTimers();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startApdexEvent", function(apdexEvent) {
        _this._apdexEvent.start(apdexEvent);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getApdexStart", function(apdexEvent) {
        return _this._apdexEvent.getStart(apdexEvent);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stopApdexEvent", function(apdexEvent, callback) {
        _this._apdexEvent.stop(apdexEvent, callback);
    });
    // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startLowPriorityEventDelay", function(timeout, callback) {
        _this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stopLowPriorityEventDelay", function() {
        _this.eventDelayQueue.stopLowPriorityEventDelay();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "onEvent", function(analyticsId, analyticsData) {
        if (!analyticsData) throw new Error("Missing analyticsData");
        if (!analyticsData.eventType) throw new Error("Missing analyticsData.eventType");
        if (analyticsData.eventType === (0, $22Iz2.eventType).TRACK) return _this.sendTrackEvent(analyticsData);
        else if (analyticsData.eventType === (0, $22Iz2.eventType).UI) return _this.sendUIEvent(analyticsData);
        else if (analyticsData.eventType === (0, $22Iz2.eventType).OPERATIONAL) return _this.sendOperationalEvent(analyticsData);
        else if (analyticsData.eventType === (0, $22Iz2.eventType).SCREEN) return _this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
        else if (analyticsData.eventType === (0, $22Iz2.eventType).IDENTIFY) return _this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
        throw new Error("Invalid analyticsData.eventType '".concat(analyticsData.eventType, "', ") + "must be an eventType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.eventType)), "]"));
    });
    if (!productInfo) throw new Error("Missing productInfo");
    if (!productInfo.env) throw new Error("Missing productInfo.env");
    if (!productInfo.product) throw new Error("Missing productInfo.product");
    if (!(0, $22Iz2.isType)((0, $22Iz2.envType), productInfo.env)) throw new Error("Invalid productInfo.env '".concat(productInfo.env, "', ") + "must be an envType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.envType)), "]"));
    if (productInfo.perimeter && !(0, $22Iz2.isType)((0, $22Iz2.perimeterType), productInfo.perimeter)) throw new Error("Invalid productInfo.perimeter '".concat(productInfo.perimeter, "', ") + "must be an perimeterType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.perimeterType)), "]"));
    if (!productInfo.origin) productInfo.origin = (0, $22Iz2.originType).WEB;
    else if (!(0, $22Iz2.isType)((0, $22Iz2.originType), productInfo.origin)) throw new Error("Invalid productInfo.origin '".concat(productInfo.origin, "', ") + "must be an originType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.originType)), "]"));
    if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $22Iz2.originType).WEB ? (0, $22Iz2.platformType).WEB : (0, $22Iz2.platformType).DESKTOP;
    else (0, $hGIZ8.validatePlatform)(productInfo);
    this.logger = settings.logger || console;
    this._productInfo = $57a84ed5054d22d2$var$_objectSpread($57a84ed5054d22d2$var$_objectSpread({}, productInfo), {}, {
        subproduct: this._createSubproductGetter(productInfo.subproduct),
        embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
    });
    this._tenantInfo = {};
    this._orgInfo = {};
    this._uiViewedAttributes = {};
    this._context = (0, $fXbpq.buildContext)(this._productInfo);
    this._safeSessionStorage = new (0, $kTmBT.default)();
    var _useStargate = this._useStargate(settings.useStargate);
    var apiHost = settings.apiHost || this._selectHost({
        useStargate: _useStargate,
        env: productInfo.env,
        useLegacyUrl: settings.useLegacyUrl,
        perimeter: productInfo.perimeter
    });
    var apiHostProtocol = settings.apiHostProtocol || "https";
    var minRetryDelay = settings.minRetryDelay || 1000;
    var retryQueueOptions = {
        maxRetryDelay: 60000,
        minRetryDelay: minRetryDelay,
        backoffFactor: 2,
        flushWaitMs: settings.flushWaitInterval,
        flushBeforeUnload: settings.flushBeforeUnload
    };
    var retryQueuePrefix = "awc-".concat(productInfo.env);
    var xidPromiseGetter = function() {
        return (0, $29bQh.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
    };
    this.eventProcessor = new (0, $lJWVG.default)({
        apiHost: apiHost,
        apiHostProtocol: apiHostProtocol,
        product: productInfo.product,
        retryQueuePrefix: retryQueuePrefix,
        retryQueueOptions: retryQueueOptions,
        xidPromiseGetter: xidPromiseGetter,
        logger: this.logger
    });
    this._userInfo = {
        anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
    };
    this._pageVisibility = new (0, $4ZR7k.default)();
    this._tabTracking = new (0, $f6Y6c.default)();
    this._sessionTracking = new (0, $jzYVM.default)({
        sessionExpiryTime: settings.sessionExpiryTime,
        onNewSessionStarted: settings.onNewSessionStarted
    });
    this.task = new (0, $1kGnl.default)();
    this.originTracing = new (0, $aHFHo.default)();
    // Init Apdex
    this._apdexEvent = new (0, $ckDXA.default)(this.sendOperationalEvent, this._pageVisibility);
    this._historyReplaceFn = typeof settings.historyReplaceFn === "function" ? settings.historyReplaceFn : (0, $gnvfh.defaultHistoryReplaceFn);
    this.eventDelayQueue = new (0, $cV8xo.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
    this._testingCache = new (0, $6f3e8.default)();
    this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))();
    this._workspaceInfo = {};
};

});
parcelRegister("ktzPa", function(module, exports) {

var $3j01n = parcelRequire("3j01n");

var $5Jjuf = parcelRequire("5Jjuf");
function $ee824e0d0744351f$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $3j01n)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $5Jjuf(rnds);
}
module.exports = $ee824e0d0744351f$var$v4;

});
parcelRegister("3j01n", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $268329a4201658b3$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($268329a4201658b3$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $268329a4201658b3$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $268329a4201658b3$var$getRandomValues($268329a4201658b3$var$rnds8);
        return $268329a4201658b3$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $268329a4201658b3$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $268329a4201658b3$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $268329a4201658b3$var$rnds;
    };
}

});

parcelRegister("5Jjuf", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $42c0456df2db3f06$var$byteToHex = [];
for(var $42c0456df2db3f06$var$i = 0; $42c0456df2db3f06$var$i < 256; ++$42c0456df2db3f06$var$i)$42c0456df2db3f06$var$byteToHex[$42c0456df2db3f06$var$i] = ($42c0456df2db3f06$var$i + 0x100).toString(16).substr(1);
function $42c0456df2db3f06$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $42c0456df2db3f06$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $42c0456df2db3f06$var$bytesToUuid;

});


parcelRegister("22Iz2", function(module, exports) {

$parcel$export(module.exports, "envType", function () { return $17ce5634d114eac5$export$56ac8ebc9870b1b9; });
$parcel$export(module.exports, "eventType", function () { return $17ce5634d114eac5$export$4c045e605d532c98; });
$parcel$export(module.exports, "platformType", function () { return $17ce5634d114eac5$export$6b4f396210e539f3; });
$parcel$export(module.exports, "originType", function () { return $17ce5634d114eac5$export$f73e9fcd368bb695; });
$parcel$export(module.exports, "tenantType", function () { return $17ce5634d114eac5$export$496f06ac2a964da2; });
$parcel$export(module.exports, "userType", function () { return $17ce5634d114eac5$export$1827adfd178b4870; });
$parcel$export(module.exports, "apdexType", function () { return $17ce5634d114eac5$export$99b37380a464d794; });
$parcel$export(module.exports, "desktopPlatforms", function () { return $17ce5634d114eac5$export$809831be6c4c6227; });
$parcel$export(module.exports, "webPlatforms", function () { return $17ce5634d114eac5$export$19c579398ad213e7; });
$parcel$export(module.exports, "originTracingType", function () { return $17ce5634d114eac5$export$62a500c02dc63ee; });
$parcel$export(module.exports, "objectValues", function () { return $17ce5634d114eac5$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "isType", function () { return $17ce5634d114eac5$export$26b9f946b448f23e; });
$parcel$export(module.exports, "perimeterType", function () { return $17ce5634d114eac5$export$bdd41749d2096e4b; });
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $17ce5634d114eac5$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $17ce5634d114eac5$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $17ce5634d114eac5$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $17ce5634d114eac5$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $17ce5634d114eac5$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $17ce5634d114eac5$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["HALP"] = "halp";
    return userType;
}({});
var $17ce5634d114eac5$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
var $17ce5634d114eac5$export$809831be6c4c6227 = Object.freeze([
    $17ce5634d114eac5$export$6b4f396210e539f3.DESKTOP,
    $17ce5634d114eac5$export$6b4f396210e539f3.MAC,
    $17ce5634d114eac5$export$6b4f396210e539f3.LINUX,
    $17ce5634d114eac5$export$6b4f396210e539f3.WINDOWS
]);
var $17ce5634d114eac5$export$19c579398ad213e7 = Object.freeze([
    $17ce5634d114eac5$export$6b4f396210e539f3.WEB,
    $17ce5634d114eac5$export$6b4f396210e539f3.MOBILE_WEB
]);
var $17ce5634d114eac5$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $17ce5634d114eac5$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $17ce5634d114eac5$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $17ce5634d114eac5$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});

});

parcelRegister("ckDXA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fa6598a1a3631a9$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");

var $22Iz2 = parcelRequire("22Iz2");

var $4ZR7k = parcelRequire("4ZR7k");

var $b7KV0 = parcelRequire("b7KV0");
function $8fa6598a1a3631a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fa6598a1a3631a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fa6598a1a3631a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fa6598a1a3631a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8fa6598a1a3631a9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function ApdexEvent(onEvent, pageVisibility) {
        var _this = this;
        (0, $4GJKx._)(this, ApdexEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getEventKey", function(param) {
            var task = param.task, taskId = param.taskId;
            return taskId ? "".concat(task, ".").concat(taskId) : task;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getEventTimingByName", function(name) {
            var eventTimings = _this._performance.getEntriesByName(name);
            var eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getApdexFields", function(event) {
            var apdexTimings = _this._getApdexTimings(event);
            var apdexScore = _this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $8fa6598a1a3631a9$var$_objectSpread($8fa6598a1a3631a9$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getApdexTimings", function(event) {
            var eventKey = _this._getEventKey(event);
            var eventStartName = "".concat(eventKey, "-start");
            var startTime = event.startTime || _this._getStartTime(event, eventStartName);
            var stopTime = event.stopTime || _this._getStopTime();
            // We do some clean up of the marks and started events
            _this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getStartTime", function(event, eventName) {
            var startTime;
            var timeOrigin = _this._performance.getTimeOrigin();
            if (event.type === (0, $22Iz2.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                var eventTiming = _this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getStopTime", function() {
            return _this._performance.getTimeOrigin() + _this._performance.now();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_cleanApdexState", function(eventKey) {
            _this._performance.clearMarks("".concat(eventKey, "-start"));
            _this._performance.clearMarks("".concat(eventKey, "-stop"));
            _this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getVisibilityFields", function(event) {
            var isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $22Iz2.apdexType).INITIAL_LOAD) isActiveTab = !_this._wasPreviouslyHidden;
            else if (event.type === (0, $22Iz2.apdexType).TRANSITION) {
                var eventKey = _this._getEventKey(event);
                isActiveTab = _this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !_this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_calculateApdex", function(param) {
            var duration = param.duration, _param_threshold = param.threshold, threshold = _param_threshold === void 0 ? _this._threshold : _param_threshold;
            var apdex;
            var satisfiedThreshold = threshold;
            var tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_validateStartEvent", function(event) {
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_validateStopEvent", function(event) {
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $22Iz2.isType)((0, $22Iz2.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== "number") throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $22Iz2.apdexType).TRANSITION) {
                var eventKey = _this._getEventKey(event);
                if (!_this._startedEvents.has(eventKey)) throw new Error('Apdex event transition "'.concat(eventKey, '" was not started'));
            }
            if (event.startTime && !(typeof event.startTime === "number" && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== "number") throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_shouldSendEvent", function(event) {
            if (!event) return false;
            if (typeof event.apdex !== "number") return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_sendEvent", function(event, callback) {
            if (_this._shouldSendEvent(event)) _this._onEvent({
                source: "ui",
                action: "readyForUser",
                actionSubject: "ui",
                attributes: $8fa6598a1a3631a9$var$_objectSpread($8fa6598a1a3631a9$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || _this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        if (!(pageVisibility instanceof (0, $4ZR7k.default))) throw new Error("Invalid pageVisibility, must be PageVisibility class");
        this._startedEvents = new Map();
        this._performance = new (0, $b7KV0.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback("apdexEvent", function(isHidden) {
            _this.onVisibilityChange(!isHidden);
        });
    }
    (0, $1wc17._)(ApdexEvent, [
        {
            key: "start",
            value: function start(event) {
                this._validateStartEvent(event);
                if (!this._performance.isAvailable()) return;
                var eventKey = this._getEventKey(event);
                var eventStartName = "".concat(eventKey, "-start");
                this._startedEvents.set(eventKey, true);
                this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
                this._performance.clearMarks(eventStartName);
                this._performance.mark(eventStartName);
            }
        },
        {
            key: "getStart",
            value: function getStart(event) {
                this._validateStartEvent(event);
                if (!this._performance.isAvailable()) return undefined;
                var eventKey = this._getEventKey(event);
                var eventStartName = "".concat(eventKey, "-start");
                return this._getEventTimingByName(eventStartName);
            }
        },
        {
            key: "stop",
            value: function stop(event, callback) {
                this._validateStopEvent(event);
                if (!this._performance.isAvailable()) return;
                var apdexFields = this._getApdexFields(event);
                var visibilityFields = this._getVisibilityFields(event);
                this._sendEvent($8fa6598a1a3631a9$var$_objectSpread($8fa6598a1a3631a9$var$_objectSpread($8fa6598a1a3631a9$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
            }
        },
        {
            key: "onVisibilityChange",
            value: function onVisibilityChange(isActive) {
                var _this = this;
                if (!isActive) {
                    this._wasPreviouslyHidden = true;
                    this._isActiveEvents.forEach(function(value, key) {
                        return _this._isActiveEvents.set(key, false);
                    });
                }
            }
        }
    ]);
    return ApdexEvent;
}();

});
parcelRegister("4ZR7k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a360fea97058cb5$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");
var $3a360fea97058cb5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function PageVisibility() {
        var _this = this;
        (0, $4GJKx._)(this, PageVisibility);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_bindEventListeners", function() {
            document.addEventListener(_this._visibilityChange, _this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_handleVisibilityChange", function() {
            var isHidden = document[_this._hidden];
            _this._isHidden = isHidden;
            _this._callbacks.forEach(function(callbackFn) {
                return callbackFn(isHidden);
            });
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document.hidden !== "undefined") {
            // Opera 12.10 and Firefox 18 and later support
            this._isHidden = document.hidden;
            this._hidden = "hidden";
            this._visibilityChange = "visibilitychange";
        } else if (typeof document.msHidden !== "undefined") {
            this._isHidden = document.msHidden;
            this._hidden = "msHidden";
            this._visibilityChange = "msvisibilitychange";
        } else if (typeof document.webkitHidden !== "undefined") {
            this._isHidden = document.webkitHidden;
            this._hidden = "webkitHidden";
            this._visibilityChange = "webkitvisibilitychange";
        }
        if (typeof document.addEventListener !== "undefined" && this._hidden !== undefined) this._bindEventListeners();
    }
    (0, $1wc17._)(PageVisibility, [
        {
            key: "addCallback",
            value: function addCallback(name, fn) {
                if (typeof name !== "string") throw new Error("Invalid name, must be string");
                if (typeof fn !== "function") throw new Error("Invalid callback, must be function");
                this._callbacks.set(name, fn);
            }
        },
        {
            key: "removeCallback",
            value: function removeCallback(name) {
                if (this._callbacks.has(name)) this._callbacks.delete(name);
            }
        },
        {
            key: "getIsHidden",
            value: function getIsHidden() {
                return this._isHidden;
            }
        }
    ]);
    return PageVisibility;
}();

});

parcelRegister("b7KV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8194be2c1febc0f1$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");
var $8194be2c1febc0f1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Performance() {
        (0, $4GJKx._)(this, Performance);
        this._performance = window.performance;
    }
    (0, $1wc17._)(Performance, [
        {
            key: "clearMarks",
            value: function clearMarks() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this__performance;
                if (!this._performance || !this._performance.clearMarks) return;
                (_this__performance = this._performance).clearMarks.apply(_this__performance, (0, $c6Xmf._)(args));
            }
        },
        {
            key: "mark",
            value: function mark() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this__performance;
                if (!this._performance || !this._performance.mark) return;
                (_this__performance = this._performance).mark.apply(_this__performance, (0, $c6Xmf._)(args));
            }
        },
        {
            key: "getEntriesByName",
            value: function getEntriesByName() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _this__performance;
                if (!this._performance || !this._performance.getEntriesByName) return [];
                return (_this__performance = this._performance).getEntriesByName.apply(_this__performance, (0, $c6Xmf._)(args));
            }
        },
        {
            key: "getTimeOrigin",
            value: function getTimeOrigin() {
                if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
                return this._performance.timeOrigin || this._performance.timing.navigationStart;
            }
        },
        {
            key: "now",
            value: function now() {
                if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
                return this._performance.now();
            }
        },
        {
            key: "isAvailable",
            value: function isAvailable() {
                return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
            }
        }
    ]);
    return Performance;
}();

});


parcelRegister("awX4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7aaab75e78d66d31$export$2e2bcd8739ae039; });
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ var $7aaab75e78d66d31$var$isFunction = function(possibleFn) {
    return typeof possibleFn === "function";
};
var $7aaab75e78d66d31$export$2e2bcd8739ae039 = function(possibleFn, errorMessage) {
    return function() {
        if ($7aaab75e78d66d31$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error("".concat(errorMessage, " - ").concat(e instanceof Error ? e.message : String(e)));
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("fXbpq", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", function () { return $b9d5374a2b5f2fb7$export$655ecf7241feac42; });
$parcel$export(module.exports, "buildScreenEvent", function () { return $b9d5374a2b5f2fb7$export$c7d9a5f56acc4b19; });
$parcel$export(module.exports, "buildActionName", function () { return $b9d5374a2b5f2fb7$export$9c5623a792efc9b0; });
$parcel$export(module.exports, "buildContext", function () { return $b9d5374a2b5f2fb7$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "buildActionEvent", function () { return $b9d5374a2b5f2fb7$export$7bf451af4a8e3dd9; });

var $3sHb8 = parcelRequire("3sHb8");

var $jjExS = parcelRequire("jjExS");

var $22Iz2 = parcelRequire("22Iz2");

var $bnlwi = parcelRequire("bnlwi");
function $b9d5374a2b5f2fb7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b9d5374a2b5f2fb7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b9d5374a2b5f2fb7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b9d5374a2b5f2fb7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b9d5374a2b5f2fb7$var$libraryVersion = "4.18.0";
function $b9d5374a2b5f2fb7$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $b9d5374a2b5f2fb7$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $b9d5374a2b5f2fb7$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $b9d5374a2b5f2fb7$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $b9d5374a2b5f2fb7$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $b9d5374a2b5f2fb7$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $b9d5374a2b5f2fb7$var$buildProductFields(productInfo, productOverrides) {
    var overrides = productOverrides || {};
    var env = $b9d5374a2b5f2fb7$var$getProductField(productInfo.env, overrides.env);
    var product = $b9d5374a2b5f2fb7$var$getProductField(productInfo.product, overrides.product);
    var subproduct = $b9d5374a2b5f2fb7$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    var version = $b9d5374a2b5f2fb7$var$getProductField(productInfo.version, overrides.version);
    var origin = $b9d5374a2b5f2fb7$var$getProductField(productInfo.origin, overrides.origin);
    var platform = $b9d5374a2b5f2fb7$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $b9d5374a2b5f2fb7$var$isNotEmptyObject(obj) {
    return (0, $bnlwi.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $b9d5374a2b5f2fb7$var$buildAttributesWithName(name, attrObject) {
    return $b9d5374a2b5f2fb7$var$isNotEmptyObject(attrObject) ? (0, $3sHb8._)({}, name, attrObject) : undefined;
}
function $b9d5374a2b5f2fb7$var$buildAttributes(attributes) {
    return $b9d5374a2b5f2fb7$var$buildAttributesWithName("attributes", attributes);
}
function $b9d5374a2b5f2fb7$export$3f5115a568819c1a(containers) {
    var validContainers = {};
    Object.keys(containers).forEach(function(key) {
        var value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $b9d5374a2b5f2fb7$export$f045f238d77c002a(containers) {
    if ($b9d5374a2b5f2fb7$var$isNotEmptyObject(containers)) {
        var validContainers = $b9d5374a2b5f2fb7$export$3f5115a568819c1a(containers);
        return $b9d5374a2b5f2fb7$var$buildAttributesWithName("containers", validContainers);
    }
    return undefined;
}
function $b9d5374a2b5f2fb7$export$655ecf7241feac42(event, actionEventType) {
    return $b9d5374a2b5f2fb7$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $b9d5374a2b5f2fb7$export$f045f238d77c002a(event.containers));
}
function $b9d5374a2b5f2fb7$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $b9d5374a2b5f2fb7$var$buildAttributesWithName("nonPrivacySafeAttributes", nonPrivacySafeAttributes);
}
function $b9d5374a2b5f2fb7$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers) {
    var productFields = $b9d5374a2b5f2fb7$var$buildProductFields(productInfo);
    var tenantFields = $b9d5374a2b5f2fb7$var$buildTenantFields(tenantInfo);
    var userFields = $b9d5374a2b5f2fb7$var$buildUserFields(userInfo);
    var orgFields = $b9d5374a2b5f2fb7$var$buildOrgFields(orgInfo);
    var workspaceFields = $b9d5374a2b5f2fb7$var$buildWorkspaceFields(workspaceInfo);
    var overrides = {
        title: "",
        path: "",
        url: "",
        referrer: "",
        search: "",
        eventType: (0, $22Iz2.eventType).SCREEN
    };
    return $b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $b9d5374a2b5f2fb7$var$buildAttributes(attributes)), $b9d5374a2b5f2fb7$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $b9d5374a2b5f2fb7$export$f045f238d77c002a(containers)), $b9d5374a2b5f2fb7$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields);
}
function $b9d5374a2b5f2fb7$export$9c5623a792efc9b0(event) {
    return "".concat(event.actionSubject, " ").concat(event.action);
}
function $b9d5374a2b5f2fb7$export$3a7fe28f9bf4f3d9(productInfo) {
    var screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: "analytics.js",
                version: $b9d5374a2b5f2fb7$var$libraryVersion
            }
        }
    };
}
function $b9d5374a2b5f2fb7$export$e3d99b4bfec06f6e(event) {
    var env = event.env, product = event.product, subproduct = event.subproduct, version = event.version, origin = event.origin, platform = event.platform;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $b9d5374a2b5f2fb7$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo) {
    var productFields = $b9d5374a2b5f2fb7$var$buildProductFields(productInfo, $b9d5374a2b5f2fb7$export$e3d99b4bfec06f6e(event));
    var tenantFields = $b9d5374a2b5f2fb7$var$buildTenantFields(tenantInfo);
    var orgFields = $b9d5374a2b5f2fb7$var$buildOrgFields(orgInfo);
    var workspaceFields = $b9d5374a2b5f2fb7$var$buildWorkspaceFields(workspaceInfo);
    var userFields = $b9d5374a2b5f2fb7$var$buildUserFields(userInfo);
    var actionFields = $b9d5374a2b5f2fb7$export$655ecf7241feac42(event, actionEventType);
    return $b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread($b9d5374a2b5f2fb7$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $b9d5374a2b5f2fb7$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields);
}

});
parcelRegister("bnlwi", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $8482891bb802977c$export$53b83ca8eaab0383; });
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $8482891bb802977c$var$isObject(val) {
    return val !== null && typeof val === "object" && Array.isArray(val) === false;
}
function $8482891bb802977c$var$isObjectObject(o) {
    return $8482891bb802977c$var$isObject(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
function $8482891bb802977c$export$53b83ca8eaab0383(o) {
    if ($8482891bb802977c$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    var ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    var prot = ctor.prototype;
    if ($8482891bb802977c$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!("isPrototypeOf" in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("cV8xo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96816e4b771ed4fa$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $8ngHp = parcelRequire("8ngHp");

var $l1AWj = parcelRequire("l1AWj");

var $99h0F = parcelRequire("99h0F");
var $96816e4b771ed4fa$export$2e2bcd8739ae039 = function EventDelayCoordinator(fireDelayedEvent, compressors) {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, EventDelayCoordinator);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "push", function(identifier, builtEvent, context, userInfo) {
        _this.delayQueue.push(identifier, builtEvent, context, userInfo);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startLowPriorityEventDelay", function() {
        var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $8ngHp.DEFAULT_DELAY_TIMEOUT), callback = arguments.length > 1 ? arguments[1] : void 0;
        if (Number.isNaN(timeout) || timeout <= 0) throw new Error("Invalid timeout period: ".concat(timeout, ", must be a number greater than 0"));
        if (_this.delayTimeout) clearTimeout(_this.delayTimeout);
        var delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $8ngHp.MAX_DELAY_TIMEOUT)) : (0, $8ngHp.MAX_DELAY_TIMEOUT);
        _this.delayCallback = callback;
        _this.delayTimeout = setTimeout(function() {
            return _this.stopLowPriorityEventDelay((0, $99h0F.StopLowPriorityEventDelayReason).TIMEOUT);
        }, delayTimeoutPeriod);
        // If the queue is still flushing from a previous delay period, then we should cancel that flush
        // to stop it from negatively impacting the performance of the new critical section
        _this.delayQueue.cancelFlush();
        _this.isDelaying = true;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stopLowPriorityEventDelay", function() {
        var reason = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $99h0F.StopLowPriorityEventDelayReason).MANUAL;
        var _this$delayCallback;
        if (_this.delayTimeout) {
            clearTimeout(_this.delayTimeout);
            _this.delayTimeout = undefined;
        }
        _this.delayQueue.startFlush();
        _this.isDelaying = false;
        (_this$delayCallback = _this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(_this, reason);
        _this.delayCallback = undefined;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "isDelayingLowPriorityEvents", function() {
        return _this.isDelaying;
    });
    this.isDelaying = false;
    this.delayQueue = new (0, $l1AWj.default)(fireDelayedEvent, compressors);
};

});
parcelRegister("8ngHp", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", function () { return $618d6cd454ff9edb$export$cf090d5281b5ae06; });
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", function () { return $618d6cd454ff9edb$export$8575e30be0feb909; });
var $618d6cd454ff9edb$export$cf090d5281b5ae06 = 10000;
var $618d6cd454ff9edb$export$8575e30be0feb909 = 30000;

});

parcelRegister("l1AWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4e6585def54a811$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $cv9Rk = parcelRequire("cv9Rk");

var $jjExS = parcelRequire("jjExS");

var $fXbpq = parcelRequire("fXbpq");

var $9kC89 = parcelRequire("9kC89");

var $aBIpN = parcelRequire("aBIpN");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
var $f4e6585def54a811$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
var $f4e6585def54a811$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
var $f4e6585def54a811$export$2e2bcd8739ae039 = function EventDelayQueue(processFn, compressionRules) {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, EventDelayQueue);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "push", function(identifier, builtEvent, context, userInfo) {
        _this.eventArgs.push({
            identifier: identifier,
            builtEvent: builtEvent,
            context: context,
            userInfo: userInfo
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "size", function() {
        return _this.eventArgs.length;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startFlush", function() {
        try {
            _this.eventArgs = _this.compressEventArgs(_this.eventArgs);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Failed to perform compression on the delayed analytics events. " + "Error: ".concat(e.message, ". Sending ").concat(_this.eventArgs.length, " uncompressed events instead"));
        }
        _this.flushNextBatch();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "cancelFlush", function() {
        if (_this.flushBatchTimeout) {
            clearTimeout(_this.flushBatchTimeout);
            _this.flushBatchTimeout = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "flushNextBatch", function() {
        var batch = _this.eventArgs.splice(0, $f4e6585def54a811$var$FLUSH_BATCH_SIZE);
        batch.forEach(function(item) {
            return _this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo);
        });
        if (_this.eventArgs.length > 0) _this.flushBatchTimeout = setTimeout(function() {
            return _this.flushNextBatch();
        }, $f4e6585def54a811$var$FLUSH_BATCH_BACKOFF_PERIOD);
        else _this.flushBatchTimeout = null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "compressEventArgs", function(eventArgs) {
        var _partition = (0, $cv9Rk._)((0, $9kC89.partition)(eventArgs, function(args) {
            return _this.compressor.canCompress(args.builtEvent);
        }), 2), compressibleEventArgs = _partition[0], incompressibleEventArgs = _partition[1];
        // Events can only be compressed together if they share the same context and user info, since these are top-level
        // fields that need to exist on the fired event and can only be set to a single value.
        // We can achieve this by grouping our events by context prior to passing them to the compressor.
        var contextGroups = compressibleEventArgs.reduce(function(groups, args) {
            var matchingGroup = groups.find(function(group) {
                return (0, $9kC89.equals)(group.userInfo, args.userInfo) && (0, $9kC89.equals)(group.context, args.context);
            });
            if (matchingGroup) matchingGroup.eventArgs.push(args);
            else groups.push({
                userInfo: args.userInfo,
                context: args.context,
                eventArgs: [
                    args
                ]
            });
            return groups;
        }, []);
        // Run the compressor on each group
        var allCompressedEventArgs = contextGroups.reduce(function(acc, group) {
            try {
                var events = group.eventArgs.map(function(args) {
                    return args.builtEvent;
                });
                var compressedEvents = _this.compressor.compress(events);
                var compressedEventArgs = compressedEvents.map(function(compressedEvent) {
                    return {
                        identifier: (0, $fXbpq.buildActionName)(compressedEvent),
                        builtEvent: compressedEvent,
                        userInfo: group.userInfo,
                        context: group.context
                    };
                });
                return acc.concat(compressedEventArgs);
            } catch (e) {
                // If anything goes wrong while compressing this group, then just fall back on the
                // uncompressed events instead. The event compressor already handles errors with invalid
                // generator functions or results, but this is an extra layer of defense to prevent data
                // loss in the event of an unexpected error.
                // eslint-disable-next-line no-console
                console.warn("Failed to compress some analytics events. " + "Error: ".concat(e.message, ". Sending ").concat(group.eventArgs.length, " uncompressed events instead"));
                return group.eventArgs;
            }
        }, []);
        incompressibleEventArgs.forEach(function(args) {
            return allCompressedEventArgs.push(args);
        });
        return allCompressedEventArgs;
    });
    this.processFn = processFn;
    this.flushBatchTimeout = null;
    this.eventArgs = [];
    this.compressor = new (0, $aBIpN.default)(compressionRules);
};

});
parcelRegister("9kC89", function(module, exports) {

$parcel$export(module.exports, "mapKeys", function () { return $6cb38f41250c2d06$export$781522908e4e76a1; });
$parcel$export(module.exports, "pick", function () { return $6cb38f41250c2d06$export$357523c63a2253b9; });
$parcel$export(module.exports, "omitBy", function () { return $6cb38f41250c2d06$export$d7a617dda645b4e3; });
$parcel$export(module.exports, "pickBy", function () { return $6cb38f41250c2d06$export$b460b275d6c6aa0; });
$parcel$export(module.exports, "omit", function () { return $6cb38f41250c2d06$export$30a06c8d3562193f; });
$parcel$export(module.exports, "equals", function () { return $6cb38f41250c2d06$export$e9bab7fafb253603; });
$parcel$export(module.exports, "partition", function () { return $6cb38f41250c2d06$export$b29f828819edca8d; });
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
var $6cb38f41250c2d06$export$781522908e4e76a1 = function(obj, fn) {
    return Object.keys(obj).reduce(function(acc, k) {
        var key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/pick
var $6cb38f41250c2d06$export$357523c63a2253b9 = function(obj, arr) {
    return arr.reduce(function(acc, curr) {
        return curr in obj && (acc[curr] = obj[curr]), acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/omit-by
var $6cb38f41250c2d06$export$d7a617dda645b4e3 = function(obj, fn) {
    return Object.keys(obj).filter(function(k) {
        return !fn(obj[k], k);
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/pick-by
var $6cb38f41250c2d06$export$b460b275d6c6aa0 = function(obj, fn) {
    return Object.keys(obj).filter(function(k) {
        return fn(obj[k], k);
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/omit
var $6cb38f41250c2d06$export$30a06c8d3562193f = function(obj, arr) {
    return Object.keys(obj).filter(function(k) {
        return arr.indexOf(k) < 0;
    }).reduce(function(acc, key) {
        return acc[key] = obj[key], acc;
    }, {});
};
// https://www.30secondsofcode.org/js/s/equals
var $6cb38f41250c2d06$export$e9bab7fafb253603 = function(a, b) {
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== "object" && typeof b !== "object") return a === b;
    if (a.prototype !== b.prototype) return false;
    var keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every(function(k) {
        return $6cb38f41250c2d06$export$e9bab7fafb253603(a[k], b[k]);
    });
};
// https://www.30secondsofcode.org/js/s/partition
var $6cb38f41250c2d06$export$b29f828819edca8d = function(arr, fn) {
    return arr.reduce(// eslint-disable-next-line no-shadow
    function(acc, val, i, arr) {
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);
};

});

parcelRegister("aBIpN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b8fcffac6fdef32$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $fXbpq = parcelRequire("fXbpq");

var $9kC89 = parcelRequire("9kC89");

var $d4mMe = parcelRequire("d4mMe");
function $7b8fcffac6fdef32$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b8fcffac6fdef32$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b8fcffac6fdef32$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b8fcffac6fdef32$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7b8fcffac6fdef32$export$2e2bcd8739ae039 = function EventCompressor() {
    "use strict";
    var compressionRules = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var _this = this;
    (0, $4GJKx._)(this, EventCompressor);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "canCompress", function(event) {
        return _this.compressionRules.some(function(compressionRule) {
            return compressionRule.canCompress(event);
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "compress", function(events) {
        var groups = _this.createGroups(events);
        return groups.reduce(function(allCompressedEvents, group) {
            var groupCompressedEvents = _this.compressGroup(group);
            return allCompressedEvents.concat(groupCompressedEvents);
        }, []);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "createGroups", function(events) {
        return(// Group events based on contextual fields. These fields are anything that is added by the client itself,
        // rather than passed in by the caller (eg. product, org. and tenant info)
        events.reduce(function(groups, event) {
            var matchingCompressor = _this.compressionRules.find(function(compressor) {
                return compressor.canCompress(event);
            });
            var contextFields;
            if (matchingCompressor) {
                var actionFields = (0, $fXbpq.buildActionFields)(event, event.eventType);
                contextFields = (0, $9kC89.omit)(event, Object.keys(actionFields));
            }
            var matchingGroup = groups.find(function(group) {
                return matchingCompressor === group.compressor && (0, $9kC89.equals)(contextFields, group.contextFields);
            });
            if (matchingGroup) matchingGroup.events.push(event);
            else groups.push({
                contextFields: contextFields,
                compressor: matchingCompressor,
                events: [
                    event
                ]
            });
            return groups;
        }, []));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "compressGroup", function(group) {
        // If this group doesn't have any compressor, then the event args are already in their final format
        if (!group.compressor) return group.events;
        try {
            // Run the compressor on the group to generate some new events.
            // The compression function is only expected to return the action fields for each
            // event that it generates, since all other fields are generated by the client.
            var compressedEventActionFields = group.compressor.compress(group.events);
            // Add the context fields to each of the resulting events to inflate them into a full action event
            return compressedEventActionFields.map(function(actionFields) {
                return $7b8fcffac6fdef32$var$_objectSpread($7b8fcffac6fdef32$var$_objectSpread({}, actionFields), group.contextFields);
            });
        } catch (e) {
            // If we fail to compress the events, then just fall back the uncompressed events
            // so that no data is lost. This can happen if the compression function throws an error
            // or returns some invalid event payloads.
            // eslint-disable-next-line no-console
            console.warn("Failed to compress some analytics events. " + "Error: ".concat(e.message, ". Sending ").concat(group.events.length, " uncompressed events instead"));
            return group.events;
        }
    });
    if (!Array.isArray(compressionRules)) throw new Error("Event compressors must be constructed with an array of CompressionRules");
    if (!compressionRules.every(function(rule) {
        return rule instanceof (0, $d4mMe.CompressionRule);
    })) throw new Error("Event compressors can only be constructed with instances of CompressionRule");
    this.compressionRules = compressionRules;
};

});
parcelRegister("d4mMe", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", function () { return $983d5121f37adc47$export$89b3253ddfd2e6e8; });

var $4GJKx = parcelRequire("4GJKx");

var $cv9Rk = parcelRequire("cv9Rk");

var $jjExS = parcelRequire("jjExS");

var $hGIZ8 = parcelRequire("hGIZ8");

var $9kC89 = parcelRequire("9kC89");
var $983d5121f37adc47$export$89b3253ddfd2e6e8 = function CompressionRule(predicate, compressFn) {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, CompressionRule);
    /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "canCompress", function(event) {
        try {
            return event && (0, $hGIZ8.isActionEventType)(event.eventType) && _this.predicate(event);
        } catch (e) {
            return false;
        }
    });
    /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "compress", function(events) {
        var _partition = (0, $cv9Rk._)((0, $9kC89.partition)(events, function(event) {
            return _this.canCompress(event);
        }), 2), compatibleEvents = _partition[0], incompatibleEvents = _partition[1];
        var compressedEvents = _this.compressFn(compatibleEvents);
        if (!compressedEvents) throw new Error("No events were returned from the compression function");
        compressedEvents.forEach(function(event) {
            (0, $hGIZ8.validateActionEventType)(event.eventType);
            (0, $hGIZ8.validateActionEvent)(event);
        });
        return compressedEvents.concat(incompatibleEvents);
    });
    if (typeof predicate !== "function") throw new Error("Invalid predicate, must be a function that accepts an event and returns a boolean");
    if (typeof compressFn !== "function") throw new Error("Invalid compressFn, must be a function that both accepts and returns an array of events");
    this.predicate = predicate;
    this.compressFn = compressFn;
};

});
parcelRegister("hGIZ8", function(module, exports) {

$parcel$export(module.exports, "validateContainers", function () { return $ce0940fca92b809a$export$e63ea5d8477971d3; });
$parcel$export(module.exports, "isActionEventType", function () { return $ce0940fca92b809a$export$d19cebda16f7579a; });
$parcel$export(module.exports, "validateActionEventType", function () { return $ce0940fca92b809a$export$4a8d7476662aebcc; });
$parcel$export(module.exports, "validateActionEvent", function () { return $ce0940fca92b809a$export$e0c121325c66ed4c; });
$parcel$export(module.exports, "validateScreenEvent", function () { return $ce0940fca92b809a$export$dc993432a592dc27; });
$parcel$export(module.exports, "validateTrackEvent", function () { return $ce0940fca92b809a$export$8c014fd74b0c8b99; });
$parcel$export(module.exports, "validateUIEvent", function () { return $ce0940fca92b809a$export$e5bac0930c812e90; });
$parcel$export(module.exports, "validateOperationalEvent", function () { return $ce0940fca92b809a$export$1e561554275607ef; });
$parcel$export(module.exports, "validateIdentifyEvent", function () { return $ce0940fca92b809a$export$c16a4e16aa4026c0; });
$parcel$export(module.exports, "validatePlatform", function () { return $ce0940fca92b809a$export$801b46c35394d316; });

var $22Iz2 = parcelRequire("22Iz2");

var $bnlwi = parcelRequire("bnlwi");
var $ce0940fca92b809a$var$actionEventTypes = Object.freeze([
    (0, $22Iz2.eventType).OPERATIONAL,
    (0, $22Iz2.eventType).TRACK,
    (0, $22Iz2.eventType).UI
]);
function $ce0940fca92b809a$export$df8ff30e3c960006(container) {
    if (!(0, $bnlwi.isPlainObject)(container)) throw new Error("properties.containers must be an Object");
    if (!("id" in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== "string") throw new Error("properties.containers.id must be of type String");
    if ("type" in container && typeof container.type !== "string") throw new Error("properties.containers.type must be of type String");
}
function $ce0940fca92b809a$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error("properties.containers must be an Object");
    Object.values(containers).forEach(function(container) {
        return $ce0940fca92b809a$export$df8ff30e3c960006(container);
    });
}
function $ce0940fca92b809a$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $22Iz2.eventType).OPERATIONAL:
        case (0, $22Iz2.eventType).TRACK:
        case (0, $22Iz2.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $ce0940fca92b809a$export$4a8d7476662aebcc(type) {
    if (!$ce0940fca92b809a$export$d19cebda16f7579a(type)) throw new Error("Invalid action event type: ".concat(type, ", must be one of: [").concat($ce0940fca92b809a$var$actionEventTypes, "]"));
    return true;
}
function $ce0940fca92b809a$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
    if (!event.action) throw new Error("Missing event.action");
    $ce0940fca92b809a$export$e63ea5d8477971d3(event.containers);
}
function $ce0940fca92b809a$export$dc993432a592dc27(name) {
    if (!name) throw new Error("Missing name");
}
function $ce0940fca92b809a$export$8c014fd74b0c8b99(event) {
    $ce0940fca92b809a$export$e0c121325c66ed4c(event);
}
function $ce0940fca92b809a$export$39d6334da9a44984(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
}
function $ce0940fca92b809a$export$e5bac0930c812e90(event) {
    $ce0940fca92b809a$export$e0c121325c66ed4c(event);
}
function $ce0940fca92b809a$export$1e561554275607ef(event) {
    $ce0940fca92b809a$export$e0c121325c66ed4c(event);
}
function $ce0940fca92b809a$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error("Missing userIdType");
    if (!userId) throw new Error("Missing userId");
    if (!(0, $22Iz2.isType)((0, $22Iz2.userType), userIdType)) throw new Error("Invalid userIdType '".concat(userIdType, "', ") + "must be an userType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.userType)), "]"));
}
function $ce0940fca92b809a$export$801b46c35394d316(productInfo) {
    if (!(0, $22Iz2.isType)((0, $22Iz2.platformType), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', ") + "must be a platformType: [".concat((0, $22Iz2.objectValues)((0, $22Iz2.platformType)), "]"));
    if (productInfo.origin === (0, $22Iz2.originType).DESKTOP && !(0, $22Iz2.isType)((0, $22Iz2.desktopPlatforms), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', ") + "must be one of [mac, linux, windows]");
    if (productInfo.origin === (0, $22Iz2.originType).WEB && !(0, $22Iz2.isType)((0, $22Iz2.webPlatforms), productInfo.platform)) throw new Error("Invalid productInfo.platform '".concat(productInfo.platform, "', must be one of [web, mobileWeb]"));
}

});




parcelRegister("99h0F", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", function () { return $01b808df67326e23$export$fa6e3729c21cb8f; });
var $01b808df67326e23$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("lJWVG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3b831d8d57614c$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $ktzPa = parcelRequire("ktzPa");

var $gXdT6 = parcelRequire("gXdT6");

var $4eyPu = parcelRequire("4eyPu");

var $445Ie = parcelRequire("445Ie");

var $alx1Y = parcelRequire("alx1Y");

var $2p4pW = parcelRequire("2p4pW");

var $7bKoC = parcelRequire("7bKoC");

var $axYp2 = parcelRequire("axYp2");

var $il7rS = parcelRequire("il7rS");
function $fd3b831d8d57614c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd3b831d8d57614c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd3b831d8d57614c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd3b831d8d57614c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fd3b831d8d57614c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function EventProcessor(options) {
        (0, $4GJKx._)(this, EventProcessor);
        var _this = this;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "sendEvents", function() {
            var _ref = (0, $kSuI9._)(function(items, callback) {
                var httpRetryCount, metricsPayload, metadata, key, eventsWithXID, sentAt, unpackagedEvents, batchBody, response, error;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            httpRetryCount = _this.resilienceQueue.getGlobalRetryCount();
                            metricsPayload = _this.metrics.getMetricsPayload();
                            metadata = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, metricsPayload), {}, {
                                httpRetryCount: httpRetryCount
                            });
                            for(var key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
                            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
                            delete metadata[key];
                            return [
                                4,
                                _this.attachXIDs(items)
                            ];
                        case 1:
                            eventsWithXID = _state.sent();
                            // Calculating sentAt after the XID generation as this may take some time.
                            sentAt = new Date().toISOString();
                            unpackagedEvents = eventsWithXID.map(function(item) {
                                item.msg.sentAt = sentAt;
                                return item.msg;
                            });
                            batchBody = {
                                batch: unpackagedEvents,
                                sentAt: sentAt,
                                metadata: metadata
                            };
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                (0, $2p4pW.sendEvents)({
                                    url: _this.gasv3BatchUrl,
                                    batch: batchBody,
                                    timeout: _this.options.requestTimeout
                                })
                            ];
                        case 3:
                            response = _state.sent();
                            _this.metrics.subtractFromMetrics(metricsPayload);
                            callback(null, response);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            callback(error, null);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(items, callback) {
                return _ref.apply(this, arguments);
            };
        }());
        this.user = new (0, $axYp2.default)();
        this.options = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $alx1Y.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console
        });
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = "".concat(options.apiHostProtocol, "://").concat(options.apiHost, "/batch");
        this.metrics = (0, $4eyPu.default)();
        this.resilienceQueue = (0, $gXdT6.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    (0, $1wc17._)(EventProcessor, [
        {
            key: "getUser",
            value: function getUser() {
                return this.user;
            }
        },
        {
            key: "track",
            value: function track(eventName, builtEvent, context, callback) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseEvent = _this.buildBaseEvent(context, (0, $7bKoC.SegmentEventTypes).TRACK, builtEvent);
                                eventWithoutMessageId = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, baseEvent), {}, {
                                    type: (0, $7bKoC.SegmentEventTypes).TRACK,
                                    properties: (0, $il7rS.prepareEventProperties)(builtEvent),
                                    event: eventName
                                });
                                event = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, eventWithoutMessageId), {}, {
                                    messageId: _this.createMessageId()
                                });
                                packagedEvent = _this.packageEvent(event);
                                return [
                                    4,
                                    _this.resilienceQueue.addItem(packagedEvent)
                                ];
                            case 1:
                                _state.sent();
                                if (callback) callback();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "page",
            value: function page(eventName, builtEvent, context, callback) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseEvent = _this.buildBaseEvent(context, (0, $7bKoC.SegmentEventTypes).PAGE, builtEvent);
                                eventWithoutMessageId = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, baseEvent), {}, {
                                    type: (0, $7bKoC.SegmentEventTypes).PAGE,
                                    properties: (0, $il7rS.prepareEventProperties)(builtEvent),
                                    name: eventName
                                });
                                event = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, eventWithoutMessageId), {}, {
                                    messageId: _this.createMessageId()
                                });
                                packagedEvent = _this.packageEvent(event);
                                return [
                                    4,
                                    _this.resilienceQueue.addItem(packagedEvent)
                                ];
                            case 1:
                                _state.sent();
                                if (callback) callback();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "identify",
            value: // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
            function identify(_identifier, builtEvent, context, callback) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var baseEvent, eventWithoutMessageId, event, packagedEvent;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                baseEvent = _this.buildBaseEvent(context, (0, $7bKoC.SegmentEventTypes).IDENTIFY, builtEvent);
                                eventWithoutMessageId = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, baseEvent), {}, {
                                    type: (0, $7bKoC.SegmentEventTypes).IDENTIFY,
                                    traits: (0, $il7rS.prepareEventProperties)(builtEvent)
                                });
                                event = $fd3b831d8d57614c$var$_objectSpread($fd3b831d8d57614c$var$_objectSpread({}, eventWithoutMessageId), {}, {
                                    messageId: _this.createMessageId()
                                });
                                packagedEvent = _this.packageEvent(event);
                                return [
                                    4,
                                    _this.resilienceQueue.addItem(packagedEvent)
                                ];
                            case 1:
                                _state.sent();
                                if (callback) callback();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "buildBaseEvent",
            value: function buildBaseEvent(context, type, overrides) {
                var clonedContext = (0, $il7rS.prepareEventProperties)(context);
                var segmentContext = (0, $il7rS.buildContext)(clonedContext);
                return {
                    context: segmentContext,
                    timestamp: new Date().toISOString(),
                    type: type,
                    userId: this.user.getUserId(),
                    anonymousId: overrides.anonymousId || this.user.getAnonymousId()
                };
            }
        },
        {
            key: "createMessageId",
            value: function createMessageId() {
                return "ajs-".concat((0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))());
            }
        },
        {
            key: "packageEvent",
            value: function packageEvent(event) {
                var _this_options = this.options, apiHost = _this_options.apiHost, apiHostProtocol = _this_options.apiHostProtocol;
                return {
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    msg: event,
                    url: "".concat(apiHostProtocol, "://").concat(apiHost, "/").concat(event.type.charAt(0))
                };
            }
        },
        {
            key: "attachXIDs",
            value: function attachXIDs(items) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    return (0, $l29cN.__generator)(this, function(_state) {
                        if (_this.xidPromiseCallback) return [
                            2,
                            (0, $445Ie.attachXidToMultipleEvents)(items, _this.xidPromiseCallback)
                        ];
                        return [
                            2,
                            Promise.resolve(items)
                        ];
                    });
                })();
            }
        }
    ]);
    return EventProcessor;
}();

});
parcelRegister("gXdT6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c57cedd9d57aefaa$export$2e2bcd8739ae039; });

var $65IGn = parcelRequire("65IGn");

var $c57cedd9d57aefaa$export$2e2bcd8739ae039 = function(retryQueuePrefix, product, options, logger) {
    return new (0, $65IGn.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("65IGn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46f5deb60691457a$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $1wZPG = parcelRequire("1wZPG");
var $2LAL4 = parcelRequire("2LAL4");

var $2470d = parcelRequire("2470d");
var $bjrva = parcelRequire("bjrva");
var $fgvDu = parcelRequire("fgvDu");

var $4eyPu = parcelRequire("4eyPu");

var $052TO = parcelRequire("052TO");

var $7cLi3 = parcelRequire("7cLi3");
var $cGib5 = parcelRequire("cGib5");

var $8g8TT = parcelRequire("8g8TT");
function $46f5deb60691457a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $46f5deb60691457a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $46f5deb60691457a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $46f5deb60691457a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $46f5deb60691457a$var$ONE_MINUTE = 60000;
var $46f5deb60691457a$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $46f5deb60691457a$var$ONE_MINUTE,
    minRetryDelay: $46f5deb60691457a$var$ONE_MINUTE,
    maxRetryDelay: $46f5deb60691457a$var$ONE_MINUTE
};
var $46f5deb60691457a$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
var $46f5deb60691457a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function PullBatchableQueue(queuePrefix, product, options, logger) {
        var _this = this;
        (0, $4GJKx._)(this, PullBatchableQueue);
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $bjrva.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $7cLi3.default)($46f5deb60691457a$var$_objectSpread($46f5deb60691457a$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $7cLi3.default)($46f5deb60691457a$var$_objectSpread($46f5deb60691457a$var$_objectSpread({}, $46f5deb60691457a$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $46f5deb60691457a$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $4eyPu.default)();
        this.networkStatus = new (0, $052TO.default)(function(status) {
            if (status === (0, $8g8TT.NetworkStatusEnum).OFFLINE) _this.scheduler.stop();
            else _this.checkEventCountAndReschedule();
        });
    }
    (0, $1wc17._)(PullBatchableQueue, [
        {
            key: "start",
            value: function start(flushCallback) {
                this.batchFlushCallback = flushCallback;
                this.longPollingScheduler.schedule();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.scheduler.stop();
                this.longPollingScheduler.stop();
            }
        },
        {
            key: "addItem",
            value: function addItem(item) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var jsonStringifiedAndParsedItem, numberOfEvictedItems;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Since Jira and Confluence use `.toJSON` on objects that should be strings
                                // And expect us to use `JSON.stringify` on these objects,
                                // And indexeddb strips these functions from the objects when adding them to the DB,
                                // We must run this silly stringify and parse before passing the event to the resilience meechanism.
                                // Planning on removing this in v4
                                jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
                                return [
                                    4,
                                    _this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $fgvDu.GuardPolicy).EVICT)
                                ];
                            case 1:
                                numberOfEvictedItems = _state.sent().numberOfEvictedItems;
                                _this.scheduler.schedule();
                                _this.metricsCollector.addToEventCount();
                                if (numberOfEvictedItems > 0) _this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getGlobalRetryCount",
            value: function getGlobalRetryCount() {
                return this.scheduler.getFailureCount();
            }
        },
        {
            key: "scheduleCallback",
            value: function scheduleCallback(done) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var result, error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Even though we stopped the scheduler, it can be restarted with a call to schedule.
                                // This could be triggered by a new event or the longPollingScheduler
                                if (_this.networkStatus.getNetworkStatus() === (0, $8g8TT.NetworkStatusEnum).OFFLINE) {
                                    done((0, $cGib5.DoneState).NOOP);
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    4,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.resilience.processItems(_this.flush.bind(_this), _this.options.batchFlushSize)
                                ];
                            case 2:
                                result = _state.sent();
                                done(result);
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                error = _state.sent();
                                if (error.name === (0, $2470d.CallbackProcessingErrorName)) {
                                    done((0, $cGib5.DoneState).ERROR);
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    _this.checkEventCountAndReschedule()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    7
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "checkEventCountAndReschedule",
            value: function checkEventCountAndReschedule() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var eventWaitingCount;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.resilience.getItemCount()
                                ];
                            case 1:
                                eventWaitingCount = _state.sent();
                                if (eventWaitingCount > 0) _this.scheduler.schedule({
                                    immediate: eventWaitingCount >= _this.options.batchFlushSize
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "scheduleLongCallBack",
            value: function scheduleLongCallBack(done) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var numberOfQueuesPurged, reclaimMetrics;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Eventually we will want to send data about how many queues were purged
                                numberOfQueuesPurged = (0, $1wZPG.default)(_this.queuePrefix);
                                _this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
                                return [
                                    4,
                                    (0, $2LAL4.default)(_this.queuePrefix, function() {
                                        var _ref = (0, $kSuI9._)(function(localStorageItems) {
                                            var itemsToAdd, _ref, addedEvents;
                                            return (0, $l29cN.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        itemsToAdd = localStorageItems.map(function(localStorageItem) {
                                                            return {
                                                                item: localStorageItem.item,
                                                                retryAttempts: localStorageItem.attemptNumber,
                                                                id: localStorageItem.id
                                                            };
                                                        });
                                                        return [
                                                            4,
                                                            _this.resilience.bulkAddItem(itemsToAdd, (0, $fgvDu.GuardPolicy).IGNORE)
                                                        ];
                                                    case 1:
                                                        _ref = _state.sent(), addedEvents = _ref.items;
                                                        if (addedEvents.length === itemsToAdd.length) return [
                                                            2,
                                                            {
                                                                status: "successful"
                                                            }
                                                        ];
                                                        else return [
                                                            2,
                                                            {
                                                                status: "partial",
                                                                acceptedItemIds: addedEvents.map(function(event) {
                                                                    return event.id;
                                                                })
                                                            }
                                                        ];
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(localStorageItems) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 1:
                                reclaimMetrics = _state.sent();
                                _this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
                                // We dont want to flush events from here as there maybe issues with analytics-service
                                // Scheduler has all the context and can schedule the next batch accordingly
                                return [
                                    4,
                                    _this.checkEventCountAndReschedule()
                                ];
                            case 2:
                                _state.sent();
                                done((0, $cGib5.DoneState).SUCCESS);
                                _this.longPollingScheduler.schedule();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "flush",
            value: function flush(wrappedItems, otherMetadata) {
                var _this = this;
                this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
                var batchFlushCallback = this.batchFlushCallback;
                if (!batchFlushCallback) throw new Error("batchFlushCallback has not been set. Call PullBatchableQueue#start first.");
                return new Promise(function(resolve, reject) {
                    if (wrappedItems.length <= 0) {
                        resolve((0, $cGib5.DoneState).NOOP);
                        return;
                    }
                    var items = wrappedItems.map(function(wrappedItem) {
                        var item = wrappedItem.item;
                        if (wrappedItem.retryAttempts > 0 && item.msg) {
                            if (!item.msg._metadata) item.msg._metadata = {};
                            item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                        }
                        return item;
                    });
                    batchFlushCallback(items, function(error) {
                        if (error) {
                            if (otherMetadata.numberOfDeletedItems > 0) _this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                            reject(error);
                        } else resolve((0, $cGib5.DoneState).SUCCESS);
                    });
                });
            }
        },
        {
            key: "buildOptions",
            value: function buildOptions(options) {
                return {
                    backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $46f5deb60691457a$export$d219df4fe04c04a7.backoffFactor,
                    backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $46f5deb60691457a$export$d219df4fe04c04a7.backoffJitterPercentage,
                    batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $46f5deb60691457a$export$d219df4fe04c04a7.batchFlushSize,
                    flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $46f5deb60691457a$export$d219df4fe04c04a7.flushBeforeUnload,
                    flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $46f5deb60691457a$export$d219df4fe04c04a7.flushWaitMs,
                    maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $46f5deb60691457a$export$d219df4fe04c04a7.maxItems,
                    maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $46f5deb60691457a$export$d219df4fe04c04a7.maxAttempts,
                    maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $46f5deb60691457a$export$d219df4fe04c04a7.maxRetryDelay,
                    minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $46f5deb60691457a$export$d219df4fe04c04a7.minRetryDelay
                };
            }
        }
    ]);
    return PullBatchableQueue;
}();

});
parcelRegister("1wZPG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11d8be3efa29ae45$export$2e2bcd8739ae039; });

var $cv9Rk = parcelRequire("cv9Rk");

var $2uE3S = parcelRequire("2uE3S");

var $kUoMr = parcelRequire("kUoMr");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
var $11d8be3efa29ae45$var$validSuffixs = Object.values((0, $2uE3S.LocalStorageKeySuffix));
var $11d8be3efa29ae45$export$2e2bcd8739ae039 = function(prefix) {
    if (typeof prefix !== "string" || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        var queueStates = Object.keys(localStorage).filter(function(key) {
            return key && key.startsWith("".concat(prefix, ".")) || false;
        }).map(function(key) {
            return key.split(".");
        }).filter(function(splitKeys) {
            return splitKeys.length === 3 && $11d8be3efa29ae45$var$validSuffixs.includes(splitKeys[2]);
        }).reduce(function(accumulator, currentKeys) {
            var _currentKeys = (0, $cv9Rk._)(currentKeys, 3), id = _currentKeys[1], suffix = _currentKeys[2];
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        var queuesToPurge = Object.keys(queueStates).filter(function(id) {
            return queueStates[id][(0, $2uE3S.LocalStorageKeySuffix).ACK] !== true;
        });
        queuesToPurge.forEach(function(id) {
            var _createLocalStorageKeys = (0, $kUoMr.createLocalStorageKeys)(prefix, id), queue = _createLocalStorageKeys.queue, inProgress = _createLocalStorageKeys.inProgress, reclaimStart = _createLocalStorageKeys.reclaimStart, reclaimEnd = _createLocalStorageKeys.reclaimEnd;
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("2uE3S", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", function () { return $1d0d7579c4b0e3c5$export$ecfa71cbc9b28241; });
$parcel$export(module.exports, "Timers", function () { return $1d0d7579c4b0e3c5$export$8bb2c1fb2b1765a9; });
var $1d0d7579c4b0e3c5$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $1d0d7579c4b0e3c5$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("kUoMr", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", function () { return $f38c427592ca2e81$export$8433d54f767cbec5; });

var $3sHb8 = parcelRequire("3sHb8");

var $2uE3S = parcelRequire("2uE3S");
var $f38c427592ca2e81$export$8433d54f767cbec5 = function(queuePrefix, queueId) {
    var _obj;
    return _obj = {}, (0, $3sHb8._)(_obj, (0, $2uE3S.LocalStorageKeySuffix).ACK, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $2uE3S.LocalStorageKeySuffix).ACK)), (0, $3sHb8._)(_obj, (0, $2uE3S.LocalStorageKeySuffix).QUEUE, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $2uE3S.LocalStorageKeySuffix).QUEUE)), (0, $3sHb8._)(_obj, (0, $2uE3S.LocalStorageKeySuffix).IN_PROGRESS, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $2uE3S.LocalStorageKeySuffix).IN_PROGRESS)), (0, $3sHb8._)(_obj, (0, $2uE3S.LocalStorageKeySuffix).RECLAIM_START, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $2uE3S.LocalStorageKeySuffix).RECLAIM_START)), (0, $3sHb8._)(_obj, (0, $2uE3S.LocalStorageKeySuffix).RECLAIM_END, "".concat(queuePrefix, ".").concat(queueId, ".").concat((0, $2uE3S.LocalStorageKeySuffix).RECLAIM_END)), _obj;
};

});


parcelRegister("2LAL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $203c7bf7b9b4bd05$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $ktzPa = parcelRequire("ktzPa");

var $2uE3S = parcelRequire("2uE3S");

var $kUoMr = parcelRequire("kUoMr");
function $203c7bf7b9b4bd05$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $203c7bf7b9b4bd05$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $203c7bf7b9b4bd05$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $203c7bf7b9b4bd05$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
var $203c7bf7b9b4bd05$var$promisedSetTimeout = function(msToWait) {
    return new Promise(function(resolve) {
        setTimeout(resolve, msToWait);
    });
};
var $203c7bf7b9b4bd05$var$findOtherQueues = function(queuePrefix) {
    try {
        return Object.keys(localStorage).filter(function(key) {
            return key.startsWith(queuePrefix);
        }).map(function(key) {
            return key.split(".");
        }).filter(function(split) {
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $2uE3S.LocalStorageKeySuffix).ACK) try {
                var ackTimestamp = localStorage.getItem(split.join("."));
                if (ackTimestamp) {
                    var ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $2uE3S.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map(function(split) {
            return split[1];
        });
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
var $203c7bf7b9b4bd05$var$tryReclaim = function() {
    var _ref = (0, $kSuI9._)(function(options, callback) {
        var _options_storageKeys, ack, reclaimStart, reclaimEnd, start;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _options_storageKeys = options.storageKeys, ack = _options_storageKeys.ack, reclaimStart = _options_storageKeys.reclaimStart, reclaimEnd = _options_storageKeys.reclaimEnd;
                    start = Date.now();
                    localStorage.setItem(reclaimStart, options.reclaimProcessId);
                    localStorage.setItem(ack, start.toString());
                    return [
                        4,
                        $203c7bf7b9b4bd05$var$promisedSetTimeout((0, $2uE3S.Timers).RECLAIM_WAIT)
                    ];
                case 1:
                    _state.sent();
                    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
                    Date.now() > start + (0, $2uE3S.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
                    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimStart.");
                    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
                    return [
                        4,
                        $203c7bf7b9b4bd05$var$promisedSetTimeout((0, $2uE3S.Timers).RECLAIM_WAIT)
                    ];
                case 2:
                    _state.sent();
                    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
                    Date.now() > start + (0, $2uE3S.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
                    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimEnd.");
                    return [
                        2,
                        $203c7bf7b9b4bd05$var$reclaim(options, callback)
                    ];
            }
        });
    });
    return function tryReclaim(options, callback) {
        return _ref.apply(this, arguments);
    };
}();
var $203c7bf7b9b4bd05$var$reclaim = function() {
    var _ref = (0, $kSuI9._)(function(options, callback) {
        var _options_storageKeys, queue, inProgress, eventsInQueue, eventsInProgress, arrayOfEventsInProgress, eventsToProcess, result, leftover;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _options_storageKeys = options.storageKeys, queue = _options_storageKeys.queue, inProgress = _options_storageKeys.inProgress;
                    // Queue is an array of events while inProgress is an object with a uuid for key
                    // Either of these queues may legitimately be missing.
                    eventsInQueue = JSON.parse(localStorage.getItem(queue) || "[]");
                    eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || "{}");
                    arrayOfEventsInProgress = Object.entries(eventsInProgress).map(function(param) {
                        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], item = _param[1];
                        var itemWithId = $203c7bf7b9b4bd05$var$_objectSpread($203c7bf7b9b4bd05$var$_objectSpread({}, item), {}, {
                            // LocalStorage-retry would add the attemptCounter after failure, rather than
                            // as it was being processed
                            attemptNumber: item.attemptNumber + 1,
                            id: key
                        });
                        return itemWithId;
                    });
                    eventsToProcess = (0, $c6Xmf._)(eventsInQueue).concat((0, $c6Xmf._)(arrayOfEventsInProgress));
                    if (!(eventsToProcess.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        callback(eventsToProcess)
                    ];
                case 1:
                    result = _state.sent();
                    if (result.status === "successful") $203c7bf7b9b4bd05$var$clearLocalStorageKeys(options.storageKeys);
                    else if (result.status === "partial") {
                        // Dont delete all events if we are only able to take some of them.
                        leftover = eventsToProcess.filter(function(event) {
                            return !result.acceptedItemIds.includes(event.id);
                        });
                        // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
                        // However, there is a very small chance that we may lose events if the process exits between these two commands.
                        localStorage.removeItem(inProgress);
                        localStorage.setItem(queue, JSON.stringify(leftover));
                        return [
                            2,
                            {
                                fullReclaim: false
                            }
                        ];
                    }
                    return [
                        3,
                        3
                    ];
                case 2:
                    $203c7bf7b9b4bd05$var$clearLocalStorageKeys(options.storageKeys);
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        {
                            fullReclaim: true
                        }
                    ];
            }
        });
    });
    return function reclaim(options, callback) {
        return _ref.apply(this, arguments);
    };
}();
// Exterminate
var $203c7bf7b9b4bd05$var$clearLocalStorageKeys = function(keys) {
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $203c7bf7b9b4bd05$export$2e2bcd8739ae039 = function() {
    var _ref = (0, $kSuI9._)(function(queuePrefix, callback) {
        var reclaimProcessId, queuesToReclaim, claims, settledClaims, failedReclaims, successfulClaims, fullReclaims, partialReclaims;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof queuePrefix !== "string" || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
                    return [
                        2,
                        {
                            fullReclaims: 0,
                            partialReclaims: 0,
                            failedReclaims: 0
                        }
                    ];
                    reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))();
                    queuesToReclaim = $203c7bf7b9b4bd05$var$findOtherQueues(queuePrefix);
                    claims = queuesToReclaim.map(function(id) {
                        return $203c7bf7b9b4bd05$var$tryReclaim({
                            queuePrefix: queuePrefix,
                            reclaimProcessId: reclaimProcessId,
                            storageKeys: (0, $kUoMr.createLocalStorageKeys)(queuePrefix, id)
                        }, callback);
                    });
                    return [
                        4,
                        Promise.allSettled(claims)
                    ];
                case 1:
                    settledClaims = _state.sent();
                    failedReclaims = settledClaims.filter(function(claim) {
                        return claim.status === "rejected";
                    });
                    successfulClaims = settledClaims.filter(function(settledValue) {
                        return settledValue.status === "fulfilled";
                    }).map(function(result) {
                        return result.value;
                    });
                    fullReclaims = successfulClaims.filter(function(claim) {
                        return claim.fullReclaim;
                    });
                    partialReclaims = successfulClaims.filter(function(claim) {
                        return !claim.fullReclaim;
                    });
                    return [
                        2,
                        {
                            failedReclaims: failedReclaims.length,
                            partialReclaims: partialReclaims.length,
                            fullReclaims: fullReclaims.length
                        }
                    ];
            }
        });
    });
    return function(queuePrefix, callback) {
        return _ref.apply(this, arguments);
    };
}();

});

parcelRegister("2470d", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", function () { return $1811630393f5d633$export$a409c8de90e11e14; });
$parcel$export(module.exports, "default", function () { return $1811630393f5d633$export$2e2bcd8739ae039; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $1811630393f5d633$export$a409c8de90e11e14 = "CallbackProcessingError";
var $1811630393f5d633$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(CallbackProcessingError, Error1);
    var _super = (0, $ohfOJ._)(CallbackProcessingError);
    function CallbackProcessingError(error) {
        (0, $4GJKx._)(this, CallbackProcessingError);
        var _this;
        var messageFromError = error && typeof error === "object" && "toString" in error && typeof error.toString === "function" && error.toString();
        var messageFromString = typeof error === "string" && error;
        var message = messageFromError || messageFromString || "Argument passed to CallbackProcessingError was not an Error or string.";
        _this = _super.call(this, "Error thrown while processing events in callback: ".concat(message));
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $d3H5E._)(_this), CallbackProcessingError.prototype);
        _this.name = $1811630393f5d633$export$a409c8de90e11e14;
        return _this;
    }
    return CallbackProcessingError;
}((0, $FuVm8._)(Error));

});

parcelRegister("bjrva", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83c6cd57033c1bf6$export$2e2bcd8739ae039; });

var $9K0bJ = parcelRequire("9K0bJ");

var $fgvDu = parcelRequire("fgvDu");

var $2470d = parcelRequire("2470d");
var $83c6cd57033c1bf6$export$2e2bcd8739ae039 = (0, $9K0bJ.default);

});
parcelRegister("9K0bJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71788e5388026835$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $fgvDu = parcelRequire("fgvDu");

var $767B8 = parcelRequire("767B8");
var $7GpsM = parcelRequire("7GpsM");

var $lNmAq = parcelRequire("lNmAq");

var $aJcKS = parcelRequire("aJcKS");

var $gyA6P = parcelRequire("gyA6P");
var $71788e5388026835$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function DbDelegator(namespace) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, DbDelegator);
        this.namespace = namespace;
        this.options = (0, $gyA6P.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== "string") throw new Error("Invalid namespace provided");
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    (0, $1wc17._)(DbDelegator, [
        {
            key: "getResilienceMechanism",
            value: function getResilienceMechanism(namespace, options) {
                if (!options.useMemory) try {
                    return new (0, $lNmAq.default)(namespace, options);
                } catch (error) {
                    if (!(error instanceof (0, $767B8.default))) {
                        var _options$logger;
                        (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn("Attempted to create IndexedDbResilience but failed. Using memory instead.");
                    }
                }
                return new (0, $aJcKS.default)(this.namespace, options);
            }
        },
        {
            key: "addItem",
            value: function addItem(item, options) {
                var policy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $fgvDu.GuardPolicy).ABANDON;
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.addItem(item, options, policy);
                });
            }
        },
        {
            key: "bulkAddItem",
            value: function bulkAddItem(itemOptions) {
                var policy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fgvDu.GuardPolicy).ABANDON;
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.bulkAddItem(itemOptions, policy);
                });
            }
        },
        {
            key: "getItems",
            value: function getItems(count) {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.getItems(count);
                });
            }
        },
        {
            key: "deleteItems",
            value: function deleteItems(itemIds) {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.deleteItems(itemIds);
                });
            }
        },
        {
            key: "getItemCount",
            value: function getItemCount() {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.getItemCount();
                });
            }
        },
        {
            key: "processItems",
            value: function processItems(processFn, count) {
                var _this = this;
                return this.runOrFailOver(function() {
                    return _this.resilience.processItems(processFn, count);
                });
            }
        },
        {
            key: "storeType",
            value: function storeType() {
                return this.resilience.storeType();
            }
        },
        {
            key: "runOrFailOver",
            value: function runOrFailOver(runnable) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    runnable()
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                error = _state.sent();
                                if (!(0, $7GpsM.shouldIgnoreResilienceDbError)(error)) return [
                                    3,
                                    3
                                ];
                                throw error;
                            case 3:
                                if (!(_this.resilience.storeType() === (0, $fgvDu.StoreType).INDEXEDDB)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this.failOver()
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    runnable()
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "failOver",
            value: function failOver() {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var oldResilience, newResilience, items, bulkAddItemsResponse, addedItemIds, error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Attempt to get any events we can and put them into memory
                                oldResilience = _this.resilience;
                                newResilience = new (0, $aJcKS.default)(_this.namespace, _this.options);
                                _this.resilience = newResilience;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    oldResilience.getItems(_this.options.maxEventLimit)
                                ];
                            case 2:
                                items = _state.sent().items;
                                if (!(items.length > 0)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    newResilience.bulkAddItemWrapperType(items, (0, $fgvDu.GuardPolicy).IGNORE)
                                ];
                            case 3:
                                bulkAddItemsResponse = _state.sent();
                                addedItemIds = bulkAddItemsResponse.items.map(function(item) {
                                    return item.id;
                                });
                                return [
                                    4,
                                    oldResilience.deleteItems(addedItemIds)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                error = _state.sent();
                                _this.options.logger.warn("Unexpected error from ResilienceDb, switching to MemoryDb");
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return DbDelegator;
}();

});
parcelRegister("fgvDu", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", function () { return $b1d0e3e54be62f41$export$d21fbb25eb37b5bf; });
$parcel$export(module.exports, "RESILIENCE_DB_NAME", function () { return $b1d0e3e54be62f41$export$8cad224051643259; });
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", function () { return $b1d0e3e54be62f41$export$3d8420be07b276ab; });
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", function () { return $b1d0e3e54be62f41$export$a512a65455fce2a6; });
$parcel$export(module.exports, "TIME_ADDED_INDEX", function () { return $b1d0e3e54be62f41$export$89d9c1ff8ac91862; });
$parcel$export(module.exports, "RETRY_INDEX", function () { return $b1d0e3e54be62f41$export$a37d385bcd713809; });
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", function () { return $b1d0e3e54be62f41$export$6d8635fed0e4b14d; });
$parcel$export(module.exports, "StoreType", function () { return $b1d0e3e54be62f41$export$39337ab5872e9457; });
$parcel$export(module.exports, "GuardPolicy", function () { return $b1d0e3e54be62f41$export$7710d69e6f450f20; });
var $b1d0e3e54be62f41$export$d21fbb25eb37b5bf = "namespace-timeAdded";
var $b1d0e3e54be62f41$export$8cad224051643259 = "analytics-web-client";
var $b1d0e3e54be62f41$export$3d8420be07b276ab = "analytics-resilience";
var $b1d0e3e54be62f41$export$a512a65455fce2a6 = "timeToBeProcessedAfter";
var $b1d0e3e54be62f41$export$89d9c1ff8ac91862 = "timeAdded";
var $b1d0e3e54be62f41$export$a37d385bcd713809 = "retryAttempts";
var $b1d0e3e54be62f41$export$6d8635fed0e4b14d = 15000;
var $b1d0e3e54be62f41$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $b1d0e3e54be62f41$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("767B8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52aefcbee4b0326f$export$2e2bcd8739ae039; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $52aefcbee4b0326f$export$fc14cf6dcea0f8ed = "NoIndexedDbError";
var $52aefcbee4b0326f$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(NoIndexedDbError, Error1);
    var _super = (0, $ohfOJ._)(NoIndexedDbError);
    function NoIndexedDbError() {
        (0, $4GJKx._)(this, NoIndexedDbError);
        var _this;
        _this = _super.call(this, "window.indexeddb is undefined.");
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $d3H5E._)(_this), NoIndexedDbError.prototype);
        _this.name = $52aefcbee4b0326f$export$fc14cf6dcea0f8ed;
        return _this;
    }
    return NoIndexedDbError;
}((0, $FuVm8._)(Error));

});

parcelRegister("7GpsM", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", function () { return $5980351f4567580c$export$74101021e0969375; });

var $1TmaA = parcelRequire("1TmaA");

var $2470d = parcelRequire("2470d");

var $24jTd = parcelRequire("24jTd");
var $5980351f4567580c$export$74101021e0969375 = function(error) {
    if (error && typeof error === "object" && "name" in error) {
        var errorWithName = error;
        return typeof errorWithName.name === "string" && (errorWithName.name === (0, $1TmaA.AbandonWriteErrorName) || errorWithName.name === (0, $2470d.CallbackProcessingErrorName) || errorWithName.name === (0, $24jTd.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("1TmaA", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", function () { return $160c1ff311a597b6$export$ba95206613c96b28; });
$parcel$export(module.exports, "default", function () { return $160c1ff311a597b6$export$2e2bcd8739ae039; });

var $d3H5E = parcelRequire("d3H5E");

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $160c1ff311a597b6$export$ba95206613c96b28 = "AbandonWriteError";
var $160c1ff311a597b6$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(AbandonWriteError, Error1);
    var _super = (0, $ohfOJ._)(AbandonWriteError);
    function AbandonWriteError(source) {
        (0, $4GJKx._)(this, AbandonWriteError);
        var _this;
        _this = _super.call(this, "Event Limit reached. Abandoning write to: ".concat(source));
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $d3H5E._)(_this), AbandonWriteError.prototype);
        _this.name = $160c1ff311a597b6$export$ba95206613c96b28;
        return _this;
    }
    return AbandonWriteError;
}((0, $FuVm8._)(Error));

});

parcelRegister("24jTd", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", function () { return $181b6220a4c3caa7$export$7e7aee9a953465ec; });
$parcel$export(module.exports, "default", function () { return $181b6220a4c3caa7$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $FuVm8 = parcelRequire("FuVm8");

var $ohfOJ = parcelRequire("ohfOJ");
var $181b6220a4c3caa7$export$7e7aee9a953465ec = "InvalidPolicyError";
var $181b6220a4c3caa7$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $dcsZi._)(InvalidPolicyError, Error1);
    var _super = (0, $ohfOJ._)(InvalidPolicyError);
    function InvalidPolicyError(policy, method) {
        (0, $4GJKx._)(this, InvalidPolicyError);
        var _this;
        _this = _super.call(this, "Method '".concat(method, "' cannot be called with policy '").concat(policy, "'."));
        _this.name = $181b6220a4c3caa7$export$7e7aee9a953465ec;
        return _this;
    }
    return InvalidPolicyError;
}((0, $FuVm8._)(Error));

});


parcelRegister("lNmAq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fddfb1c932e3c256$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $04Kcc = parcelRequire("04Kcc");

var $jjExS = parcelRequire("jjExS");

var $fgvDu = parcelRequire("fgvDu");

var $1ngTK = parcelRequire("1ngTK");

var $2470d = parcelRequire("2470d");
var $24jTd = parcelRequire("24jTd");
var $767B8 = parcelRequire("767B8");
var $7GpsM = parcelRequire("7GpsM");

var $6FFZb = parcelRequire("6FFZb");

var $gyA6P = parcelRequire("gyA6P");
var $fddfb1c932e3c256$var$_excluded = [
    "item"
], $fddfb1c932e3c256$var$_excluded2 = [
    "items"
];
function $fddfb1c932e3c256$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fddfb1c932e3c256$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fddfb1c932e3c256$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fddfb1c932e3c256$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fddfb1c932e3c256$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDbConnector(_namespace) {
        var _options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, IndexedDbConnector);
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "startDB", /*#__PURE__*/ (0, $kSuI9._)(function() {
            return (0, $l29cN.__generator)(this, function(_state) {
                return [
                    2,
                    new Promise(function() {
                        var _ref = (0, $kSuI9._)(function(resolve, reject) {
                            var request, error;
                            return (0, $l29cN.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        window.setTimeout(function() {
                                            _this.logger.warn("IndexedDB timed out.");
                                            reject(new (0, $767B8.default)());
                                        }, (0, $fgvDu.INDEXEDDB_TIMEOUT));
                                        /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ request = window.indexedDB.open((0, $fgvDu.RESILIENCE_DB_NAME), 1);
                                        request.onupgradeneeded = function(event) {
                                            if (event.oldVersion !== 0) throw new Error("We cannot upgrade the database. Do not do this.");
                                            var db = request.result;
                                            var store = db.createObjectStore((0, $fgvDu.RESILIENCE_STORE_NAME), {
                                                keyPath: "id"
                                            });
                                            store.createIndex((0, $fgvDu.TIME_TO_PROCESS_AFTER_INDEX), (0, $fgvDu.TIME_TO_PROCESS_AFTER_INDEX), {
                                                unique: false
                                            });
                                            store.createIndex((0, $fgvDu.RETRY_INDEX), (0, $fgvDu.RETRY_INDEX), {
                                                unique: false
                                            });
                                            store.createIndex((0, $fgvDu.TIME_ADDED_INDEX), (0, $fgvDu.TIME_ADDED_INDEX), {
                                                unique: false
                                            });
                                            // Compound key index of product - timeAdded.
                                            store.createIndex((0, $fgvDu.NAMESPACE_AND_TIME_ADDED_INDEX), [
                                                "namespace",
                                                "timeAdded"
                                            ], {
                                                unique: false
                                            });
                                        };
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            (0, $gyA6P.requestToPromise)(request)
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            2,
                                            resolve(request.result)
                                        ];
                                    case 3:
                                        error = _state.sent();
                                        _this.logger.warn("IndexedDB failed to initialise.", error);
                                        reject(new (0, $767B8.default)());
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(resolve, reject) {
                            return _ref.apply(this, arguments);
                        };
                    }())
                ];
            });
        }));
        var _this1 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "addItem", function() {
            var _ref = (0, $kSuI9._)(function(item) {
                var options, policy, logger, namespace, value, objectStore, bulkAddResult, error;
                var _arguments = arguments;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, policy = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : (0, $fgvDu.GuardPolicy).ABANDON;
                            logger = _this1.logger, namespace = _this1.namespace;
                            value = (0, $gyA6P.convertToItemWrapper)(item, namespace, options);
                            return [
                                4,
                                _this1.getObjectStoreAndTransaction("readwrite")
                            ];
                        case 1:
                            objectStore = _state.sent().objectStore;
                            if (policy === (0, $fgvDu.GuardPolicy).IGNORE) throw new (0, $24jTd.default)(policy, "IndexedDbConnector#addItem");
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== "string") throw new Error("Namespace not specified");
                            return [
                                4,
                                _this1.globalEventLimitGuard.insertItems(objectStore, [
                                    value
                                ], policy)
                            ];
                        case 3:
                            bulkAddResult = _state.sent();
                            if (bulkAddResult.items.length === 1) return [
                                2,
                                {
                                    item: bulkAddResult.items[0],
                                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                                }
                            ];
                            // Should never happen as the Policy and EventCountGuard should cause another pathway
                            throw new Error("Incorrect number of items added. Expected: 1, got: ".concat(bulkAddResult.items.length));
                        case 4:
                            error = _state.sent();
                            if ((0, $7GpsM.shouldIgnoreResilienceDbError)(error)) throw error;
                            logger.log("Failed to add item to table", error);
                            throw new Error("Request to add item to table failed");
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(item) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this2 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "bulkAddItem", function() {
            var _ref = (0, $kSuI9._)(function(itemOptions) {
                var policy, logger, namespace, items, objectStore, error;
                var _arguments = arguments;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            policy = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : (0, $fgvDu.GuardPolicy).ABANDON;
                            logger = _this2.logger, namespace = _this2.namespace;
                            items = itemOptions.map(function(_ref) {
                                var item = _ref.item, options = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $fddfb1c932e3c256$var$_excluded);
                                return (0, $gyA6P.convertToItemWrapper)(item, namespace, options);
                            });
                            return [
                                4,
                                _this2.getObjectStoreAndTransaction("readwrite")
                            ];
                        case 1:
                            objectStore = _state.sent().objectStore;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                _this2.globalEventLimitGuard.insertItems(objectStore, items, policy)
                            ];
                        case 3:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 4:
                            error = _state.sent();
                            if ((0, $7GpsM.shouldIgnoreResilienceDbError)(error)) throw error;
                            logger.log("Failed to add item to table", error);
                            throw new Error("Request to add item to table failed");
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(itemOptions) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this3 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getItems", /*#__PURE__*/ (0, $kSuI9._)(function() {
            var count, fixedCount, logger, maxAttempts, _ref, transaction, objectStore, timeIndex, upperBoundOpenKeyRange, request, getResult;
            var _arguments = arguments;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        count = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : (0, $1ngTK.GET_ITEM_COUNT);
                        fixedCount = count > 0 ? count : (0, $1ngTK.GET_ITEM_COUNT);
                        logger = _this3.logger;
                        maxAttempts = _this3.options.maxAttempts;
                        return [
                            4,
                            _this3.getObjectStoreAndTransaction("readwrite")
                        ];
                    case 1:
                        _ref = _state.sent(), transaction = _ref.transaction, objectStore = _ref.objectStore;
                        timeIndex = objectStore.index((0, $fgvDu.TIME_TO_PROCESS_AFTER_INDEX));
                        upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                        request = timeIndex.openCursor(upperBoundOpenKeyRange);
                        return [
                            4,
                            new Promise(function() {
                                var _ref = (0, $kSuI9._)(function(resolve, reject) {
                                    var items, numberOfDeletedItems;
                                    return (0, $l29cN.__generator)(this, function(_state) {
                                        items = [];
                                        numberOfDeletedItems = 0;
                                        request.onerror = function(error) {
                                            logger.error("Failed to open cursor:", error);
                                            reject("Failed to open cursor");
                                        };
                                        // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                                        request.onsuccess = function(event) {
                                            var cursor = event.target.result;
                                            if (cursor) {
                                                // Prevent mutation of the value we are returning
                                                var value = $fddfb1c932e3c256$var$_objectSpread({}, cursor.value);
                                                items.push(value);
                                                // Mutations seem to be required for testing indexeddb library
                                                var updatedValue = cursor.value;
                                                updatedValue.retryAttempts += 1;
                                                updatedValue.timeToBeProcessedAfter = Date.now() + (0, $1ngTK.VISIBILITY_TIMEOUT);
                                                if (updatedValue.retryAttempts >= maxAttempts) {
                                                    ++numberOfDeletedItems;
                                                    var request = cursor.delete();
                                                    (0, $gyA6P.monitorErrorsOnRequest)(request, logger);
                                                } else {
                                                    var request1 = cursor.update(updatedValue);
                                                    (0, $gyA6P.monitorErrorsOnRequest)(request1, logger);
                                                }
                                                if (items.length < fixedCount) cursor.continue();
                                                else resolve({
                                                    items: items,
                                                    numberOfDeletedItems: numberOfDeletedItems
                                                });
                                            } else resolve({
                                                items: items,
                                                numberOfDeletedItems: numberOfDeletedItems
                                            });
                                        };
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(resolve, reject) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 2:
                        getResult = _state.sent();
                        return [
                            4,
                            (0, $gyA6P.commitTransaction)(transaction, _this3.logger)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            getResult
                        ];
                }
            });
        }));
        var _this4 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "deleteItems", function() {
            var _ref = (0, $kSuI9._)(function(itemIds) {
                var _ref, transaction, objectStore, deletePromises, error;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this4.getObjectStoreAndTransaction("readwrite")
                            ];
                        case 1:
                            _ref = _state.sent(), transaction = _ref.transaction, objectStore = _ref.objectStore;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            deletePromises = itemIds.map(function(id) {
                                return _this4.deleteItem(objectStore, id);
                            });
                            return [
                                4,
                                (0, $gyA6P.commitTransaction)(transaction, _this4.logger)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                4,
                                Promise.all(deletePromises)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            _this4.logger.warn("Failed to delete items from indexeddb.", error);
                            throw error;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(itemIds) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this5 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getItemCount", /*#__PURE__*/ (0, $kSuI9._)(function() {
            var _ref, transaction, objectStore, timeIndex, upperBoundOpenKeyRange, request, event;
            return (0, $l29cN.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this5.getObjectStoreAndTransaction("readonly")
                        ];
                    case 1:
                        _ref = _state.sent(), transaction = _ref.transaction, objectStore = _ref.objectStore;
                        timeIndex = objectStore.index((0, $fgvDu.TIME_TO_PROCESS_AFTER_INDEX));
                        upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
                        request = timeIndex.count(upperBoundOpenKeyRange);
                        return [
                            4,
                            (0, $gyA6P.requestToPromise)(request)
                        ];
                    case 2:
                        event = _state.sent();
                        return [
                            4,
                            (0, $gyA6P.commitTransaction)(transaction, _this5.logger)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            event.target.result
                        ];
                }
            });
        }));
        var _this6 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "processItems", function() {
            var _ref = (0, $kSuI9._)(function(processFn) {
                var count, _await$this$getItems, items, partialResult, result, itemIds, error;
                var _arguments = arguments;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            count = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : (0, $1ngTK.GET_ITEM_COUNT);
                            return [
                                4,
                                _this6.getItems(count)
                            ];
                        case 1:
                            _await$this$getItems = _state.sent(), items = _await$this$getItems.items, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_await$this$getItems, $fddfb1c932e3c256$var$_excluded2);
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                processFn(items, partialResult)
                            ];
                        case 3:
                            result = _state.sent();
                            itemIds = items.map(function(item) {
                                return item.id;
                            });
                            // We should not await this delete as a rejected promise would get caught by the catch statement
                            return [
                                4,
                                _this6.deleteItems(itemIds)
                            ];
                        case 4:
                            _state.sent();
                            return [
                                2,
                                result
                            ];
                        case 5:
                            error = _state.sent();
                            // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                            // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                            // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                            throw new (0, $2470d.default)(error);
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(processFn) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this7 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "deleteItem", function() {
            var _ref = (0, $kSuI9._)(function(objectStore, id) {
                var logger, error;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            logger = _this7.logger;
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, $gyA6P.requestToPromise)(objectStore.delete(id))
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            logger.error("Failed to delete item:", id, error);
                            throw error;
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(objectStore, id) {
                return _ref.apply(this, arguments);
            };
        }());
        var _this8 = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getObjectStoreAndTransaction", function() {
            var _ref = (0, $kSuI9._)(function(mode) {
                var transaction, objectStore;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _this8.db
                            ];
                        case 1:
                            transaction = _state.sent().transaction((0, $fgvDu.RESILIENCE_STORE_NAME), mode);
                            objectStore = transaction.objectStore((0, $fgvDu.RESILIENCE_STORE_NAME));
                            return [
                                2,
                                {
                                    transaction: transaction,
                                    objectStore: objectStore
                                }
                            ];
                    }
                });
            });
            return function(mode) {
                return _ref.apply(this, arguments);
            };
        }());
        this.options = (0, $gyA6P.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $767B8.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(function() {});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $6FFZb.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    (0, $1wc17._)(IndexedDbConnector, [
        {
            key: "storeType",
            value: function storeType() {
                return (0, $fgvDu.StoreType).INDEXEDDB;
            }
        }
    ]);
    return IndexedDbConnector;
}();

});
parcelRegister("04Kcc", function(module, exports) {

var $ikTCA = parcelRequire("ikTCA");
function $00e43555e92d38d1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ikTCA(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
module.exports = $00e43555e92d38d1$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ikTCA", function(module, exports) {
function $d5953d7e819ca52f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $d5953d7e819ca52f$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("1ngTK", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", function () { return $10050c124a5fb3e2$export$b6df3d334cec060f; });
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", function () { return $10050c124a5fb3e2$export$14ef152a03a4b6ee; });
$parcel$export(module.exports, "MAX_ATTEMPTS", function () { return $10050c124a5fb3e2$export$da9ab7b2fd5998e8; });
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", function () { return $10050c124a5fb3e2$export$1188664dfff364c8; });
var $10050c124a5fb3e2$export$b6df3d334cec060f = 7;
var $10050c124a5fb3e2$export$14ef152a03a4b6ee = 60000;
var $10050c124a5fb3e2$export$da9ab7b2fd5998e8 = 10;
var $10050c124a5fb3e2$export$1188664dfff364c8 = 5000;

});

parcelRegister("6FFZb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4db723e5e22fa18a$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $fgvDu = parcelRequire("fgvDu");

var $1TmaA = parcelRequire("1TmaA");

var $gyA6P = parcelRequire("gyA6P");
var $4db723e5e22fa18a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDbEventCountGuard(eventLimit, namespace, logger, deleteItemHandler) {
        (0, $4GJKx._)(this, IndexedDbEventCountGuard);
        var _this = this;
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "deleteOldestNEvents", function() {
            var _ref = (0, $kSuI9._)(function(objectStore, count) {
                var _target, productTimeAddedIndex, keyRangeValues, getAllRequest, event, result, deletePromises, error;
                return (0, $l29cN.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            productTimeAddedIndex = objectStore.index((0, $fgvDu.NAMESPACE_AND_TIME_ADDED_INDEX));
                            keyRangeValues = IDBKeyRange.bound([
                                _this.namespace,
                                0
                            ], [
                                _this.namespace,
                                Date.now()
                            ]);
                            getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
                            return [
                                4,
                                (0, $gyA6P.requestToPromise)(getAllRequest)
                            ];
                        case 1:
                            event = _state.sent();
                            result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
                            if (!(result && Array.isArray(result) && result.length > 0)) return [
                                3,
                                5
                            ];
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            deletePromises = result.map(function(item) {
                                return _this.deleteItemHandler(objectStore, item);
                            });
                            return [
                                4,
                                Promise.all(deletePromises)
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            _this.logger.warn("Failed to delete items from indexeddb.", error);
                            throw error;
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(objectStore, count) {
                return _ref.apply(this, arguments);
            };
        }());
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    (0, $1wc17._)(IndexedDbEventCountGuard, [
        {
            key: "insertItems",
            value: /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ function insertItems(objectStore, items) {
                var policy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $fgvDu.GuardPolicy).ABANDON;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var itemsToAdd, numberOfEvictedItems, promises;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                itemsToAdd = (0, $c6Xmf._)(items);
                                numberOfEvictedItems = 0;
                                switch(policy){
                                    case (0, $fgvDu.GuardPolicy).ABANDON:
                                        return [
                                            3,
                                            1
                                        ];
                                    case (0, $fgvDu.GuardPolicy).EVICT:
                                        return [
                                            3,
                                            3
                                        ];
                                    case (0, $fgvDu.GuardPolicy).IGNORE:
                                        return [
                                            3,
                                            5
                                        ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 1:
                                return [
                                    4,
                                    _this.throwIfNotEnoughSpace(objectStore, items.length)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.evictIfNotEnoughSpace(objectStore, items.length)
                                ];
                            case 4:
                                numberOfEvictedItems = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                // Removed items from `itemsToAdd` if there is insufficient space
                                return [
                                    4,
                                    _this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                promises = itemsToAdd.map(function(item) {
                                    return (0, $gyA6P.requestToPromise)(objectStore.add(item));
                                });
                                return [
                                    4,
                                    Promise.all(promises)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    4,
                                    (0, $gyA6P.commitTransaction)(objectStore.transaction, _this.logger)
                                ];
                            case 9:
                                _state.sent();
                                return [
                                    2,
                                    {
                                        items: itemsToAdd,
                                        numberOfEvictedItems: numberOfEvictedItems
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "throwIfNotEnoughSpace",
            value: function throwIfNotEnoughSpace(objectStore, requiredSpace) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var freeSpace;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.calculateFreeSpace(objectStore)
                                ];
                            case 1:
                                freeSpace = _state.sent();
                                if (freeSpace < requiredSpace) throw new (0, $1TmaA.default)("Not enough space in IndexedDb. Needed ".concat(requiredSpace, " but only had ").concat(freeSpace));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "evictIfNotEnoughSpace",
            value: function evictIfNotEnoughSpace(objectStore, requiredSpace) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var freeSpace, extraSpace;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.calculateFreeSpace(objectStore)
                                ];
                            case 1:
                                freeSpace = _state.sent();
                                if (!(freeSpace < requiredSpace)) return [
                                    3,
                                    3
                                ];
                                extraSpace = requiredSpace - freeSpace;
                                return [
                                    4,
                                    _this.deleteOldestNEvents(objectStore, extraSpace)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2,
                                    extraSpace
                                ];
                            case 3:
                                return [
                                    2,
                                    0
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "calculateHowManyEventsWeCanAdd",
            value: function calculateHowManyEventsWeCanAdd(objectStore, items) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var freeSpace, numberOfItemsToRemove, start;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.calculateFreeSpace(objectStore)
                                ];
                            case 1:
                                freeSpace = _state.sent();
                                if (freeSpace < items.length) {
                                    numberOfItemsToRemove = items.length - freeSpace;
                                    start = items.length - numberOfItemsToRemove;
                                    items.splice(start, numberOfItemsToRemove);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "calculateFreeSpace",
            value: function calculateFreeSpace(objectStore) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var numberOfEventsInDb;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getCountofEventsInObjectStore(objectStore)
                                ];
                            case 1:
                                numberOfEventsInDb = _state.sent();
                                return [
                                    2,
                                    _this.eventLimit - numberOfEventsInDb
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getCountofEventsInObjectStore",
            value: /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ function getCountofEventsInObjectStore(objectStore) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var productTimeAddedIndex, keyRangeValues, request, event;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                productTimeAddedIndex = objectStore.index((0, $fgvDu.NAMESPACE_AND_TIME_ADDED_INDEX));
                                keyRangeValues = IDBKeyRange.bound([
                                    _this.namespace,
                                    0
                                ], [
                                    _this.namespace,
                                    Date.now()
                                ]);
                                request = productTimeAddedIndex.count(keyRangeValues);
                                return [
                                    4,
                                    (0, $gyA6P.requestToPromise)(request)
                                ];
                            case 1:
                                event = _state.sent();
                                return [
                                    2,
                                    event.target.result
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return IndexedDbEventCountGuard;
}();

});
parcelRegister("gyA6P", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", function () { return $c0dbd4d55ead6def$export$aec476f33d77be11; });
$parcel$export(module.exports, "createOptionsWithDefaults", function () { return $c0dbd4d55ead6def$export$ddc6718318090f71; });
$parcel$export(module.exports, "requestToPromise", function () { return $c0dbd4d55ead6def$export$85ceed0783e42041; });
$parcel$export(module.exports, "commitTransaction", function () { return $c0dbd4d55ead6def$export$feab8418f018df89; });
$parcel$export(module.exports, "monitorErrorsOnRequest", function () { return $c0dbd4d55ead6def$export$342d941b6f724995; });

var $ktzPa = parcelRequire("ktzPa");

var $1ngTK = parcelRequire("1ngTK");
var $c0dbd4d55ead6def$export$aec476f33d77be11 = function(item, namespace, param) {
    var id = param.id, retryAttempts = param.retryAttempts, timeToProcessOffset = param.timeToProcessOffset;
    return {
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    };
};
var $c0dbd4d55ead6def$export$ddc6718318090f71 = function(options) {
    return {
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $1ngTK.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $1ngTK.EVENT_COUNT_LIMIT)
    };
};
var $c0dbd4d55ead6def$export$85ceed0783e42041 = function(request) {
    return new Promise(function(resolve, reject) {
        request.onsuccess = function(event) {
            resolve(event);
        };
        request.onerror = function(event) {
            reject(event);
        };
    });
};
var $c0dbd4d55ead6def$export$2a5213bce1720b42 = function(transaction) {
    return new Promise(function(resolve, reject) {
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = function() {
            resolve();
        };
        transaction.onerror = function(event) {
            reject(event);
        };
        transaction.onabort = function(event) {
            reject(event);
        };
    });
};
var $c0dbd4d55ead6def$export$feab8418f018df89 = function(transaction, logger) {
    try {
        if (typeof transaction.commit === "function") transaction.commit();
    } catch (error) {
        logger.error("Failed to force commit transaction:", error);
        throw error;
    }
    return $c0dbd4d55ead6def$export$2a5213bce1720b42(transaction);
};
var $c0dbd4d55ead6def$export$342d941b6f724995 = function(request, logger) {
    request.onerror = function(event) {
        logger.warn("Error thrown from request:", event);
    };
};

});



parcelRegister("aJcKS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cf80040ed2dc1a9$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $04Kcc = parcelRequire("04Kcc");

var $fgvDu = parcelRequire("fgvDu");

var $1ngTK = parcelRequire("1ngTK");

var $2470d = parcelRequire("2470d");
var $24jTd = parcelRequire("24jTd");

var $9ubZ8 = parcelRequire("9ubZ8");

var $gyA6P = parcelRequire("gyA6P");
var $7cf80040ed2dc1a9$var$_excluded = [
    "item"
], $7cf80040ed2dc1a9$var$_excluded2 = [
    "items"
];
function $7cf80040ed2dc1a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7cf80040ed2dc1a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7cf80040ed2dc1a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7cf80040ed2dc1a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7cf80040ed2dc1a9$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function MemoryDb(namespace) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $4GJKx._)(this, MemoryDb);
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $gyA6P.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $9ubZ8.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    (0, $1wc17._)(MemoryDb, [
        {
            key: "addItem",
            value: /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ function addItem(item) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, policy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $fgvDu.GuardPolicy).ABANDON;
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var storedValue, bulkAddItemsResult;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (policy === (0, $fgvDu.GuardPolicy).IGNORE) throw new (0, $24jTd.default)(policy, "IndexedDbConnector#addItem");
                                storedValue = (0, $gyA6P.convertToItemWrapper)(item, _this.namespace, options);
                                return [
                                    4,
                                    _this.globalEventLimitGuard.insertItemsToMemoryStore([
                                        storedValue
                                    ], policy)
                                ];
                            case 1:
                                bulkAddItemsResult = _state.sent();
                                return [
                                    2,
                                    Promise.resolve({
                                        item: bulkAddItemsResult.items[0],
                                        numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "bulkAddItem",
            value: function bulkAddItem(itemOptions) {
                var policy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fgvDu.GuardPolicy).ABANDON;
                var _this = this;
                var items = itemOptions.map(function(_ref) {
                    var item = _ref.item, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_ref, $7cf80040ed2dc1a9$var$_excluded);
                    return (0, $gyA6P.convertToItemWrapper)(item, _this.namespace, addOptions);
                });
                return this.bulkAddItemWrapperType(items, policy);
            }
        },
        {
            /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ key: "bulkAddItemWrapperType",
            value: function bulkAddItemWrapperType(items) {
                var policy = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, $fgvDu.GuardPolicy).ABANDON;
                return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
            }
        },
        {
            key: "getItems",
            value: function getItems() {
                var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $1ngTK.GET_ITEM_COUNT);
                return Promise.resolve(this.synchronousGetItems(count));
            }
        },
        {
            key: "synchronousGetItems",
            value: function synchronousGetItems() {
                var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $1ngTK.GET_ITEM_COUNT);
                var _this = this;
                var fixedCount = count > 0 ? count : (0, $1ngTK.GET_ITEM_COUNT);
                var now = Date.now();
                var wrappedItems = [];
                var itemsToRemove = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.memoryStore[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var wrappedItem = _step.value;
                        if (wrappedItem.timeToBeProcessedAfter <= now) {
                            wrappedItems.push($7cf80040ed2dc1a9$var$_objectSpread({}, wrappedItem));
                            // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                            wrappedItem.timeToBeProcessedAfter += (0, $1ngTK.VISIBILITY_TIMEOUT);
                            wrappedItem.retryAttempts += 1;
                            if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
                        }
                        if (wrappedItems.length >= fixedCount) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                itemsToRemove.forEach(function(item) {
                    var index = _this.memoryStore.indexOf(item);
                    _this.memoryStore.splice(index, 1);
                });
                return {
                    items: wrappedItems,
                    numberOfDeletedItems: itemsToRemove.length
                };
            }
        },
        {
            key: "deleteItems",
            value: function deleteItems(itemIds) {
                this.memoryStore = this.memoryStore.filter(function(item) {
                    return !itemIds.includes(item.id);
                });
                return Promise.resolve(void 0);
            }
        },
        {
            key: "getItemCount",
            value: function getItemCount() {
                var now = Date.now();
                var count = this.memoryStore.filter(function(item) {
                    return item.timeToBeProcessedAfter <= now;
                }).length;
                return Promise.resolve(count);
            }
        },
        {
            key: "processItems",
            value: function processItems(processFn, count) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var _this$synchronousGetI, items, partialGetResult, itemIds, result, error;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this$synchronousGetI = _this.synchronousGetItems(count), items = _this$synchronousGetI.items, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_this$synchronousGetI, $7cf80040ed2dc1a9$var$_excluded2);
                                itemIds = items.map(function(i) {
                                    return i.id;
                                });
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    processFn(items, partialGetResult)
                                ];
                            case 2:
                                result = _state.sent();
                                return [
                                    4,
                                    _this.deleteItems(itemIds)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    result
                                ];
                            case 4:
                                error = _state.sent();
                                throw new (0, $2470d.default)(error);
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "storeType",
            value: function storeType() {
                return (0, $fgvDu.StoreType).MEMORY;
            }
        },
        {
            /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ key: "addItems",
            value: function addItems(itemsToAdd) {
                var _this_memoryStore;
                (_this_memoryStore = this.memoryStore).push.apply(_this_memoryStore, (0, $c6Xmf._)(itemsToAdd));
                // Sorting everytime, intentionally.
                this.memoryStore.sort(function(a, b) {
                    return a.timeAdded - b.timeAdded;
                });
            }
        },
        {
            /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ key: "evictEventsIfNeeded",
            value: function evictEventsIfNeeded(eventLimit) {
                var numberOfEventsInDb = this.memoryStore.length;
                // The number of analytics events currently in MemoryDb and
                // the Z events we are proposing to add will exceed our event count limit.
                if (numberOfEventsInDb > eventLimit) {
                    var m = numberOfEventsInDb - eventLimit;
                    // Removing oldest M events
                    this.memoryStore.splice(0, m);
                    return m;
                }
                return 0;
            }
        }
    ]);
    return MemoryDb;
}();

});
parcelRegister("9ubZ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e80365bbb36cee8$export$2e2bcd8739ae039; });

var $kSuI9 = parcelRequire("kSuI9");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $fgvDu = parcelRequire("fgvDu");

var $1TmaA = parcelRequire("1TmaA");
var $6e80365bbb36cee8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function MemoryDbEventCountGuard(eventLimit, memoryItemHandlers) {
        var _this = this;
        (0, $4GJKx._)(this, MemoryDbEventCountGuard);
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "insertItemsToMemoryStore", function(itemsToAdd, policy) {
            switch(policy){
                case (0, $fgvDu.GuardPolicy).ABANDON:
                    return _this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $fgvDu.GuardPolicy).EVICT:
                    return Promise.resolve(_this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $fgvDu.GuardPolicy).IGNORE:
                    return _this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.memoryItemHandlers = memoryItemHandlers;
    }
    (0, $1wc17._)(MemoryDbEventCountGuard, [
        {
            key: "handleAbandonIfLimitWillExceedPolicy",
            value: function handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var itemCount;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.memoryItemHandlers.getItemCount()
                                ];
                            case 1:
                                itemCount = _state.sent();
                                if (itemCount + itemsToAdd.length > _this.eventLimit) throw new (0, $1TmaA.default)((0, $fgvDu.StoreType).MEMORY);
                                _this.memoryItemHandlers.addItems(itemsToAdd);
                                return [
                                    2,
                                    {
                                        items: itemsToAdd,
                                        numberOfEvictedItems: 0
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "handleEvictOldestIfLimitExceededPolicy",
            value: function handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
                this.memoryItemHandlers.addItems(itemsToAdd);
                var numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
                return {
                    items: itemsToAdd,
                    numberOfEvictedItems: numberOfEvictedItems
                };
            }
        },
        {
            key: "handleAddAsManyAsPossible",
            value: function handleAddAsManyAsPossible(itemsToAdd) {
                var _this = this;
                return (0, $kSuI9._)(function() {
                    var freeSpace, _, partialEventsToAdd;
                    return (0, $l29cN.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.eventLimit;
                                return [
                                    4,
                                    _this.memoryItemHandlers.getItemCount()
                                ];
                            case 1:
                                freeSpace = _ - _state.sent();
                                partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
                                _this.memoryItemHandlers.addItems(partialEventsToAdd);
                                return [
                                    2,
                                    {
                                        items: partialEventsToAdd,
                                        numberOfEvictedItems: 0
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MemoryDbEventCountGuard;
}();

});




parcelRegister("4eyPu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31537ca9d7c8e25f$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");

var $8g8TT = parcelRequire("8g8TT");
var $31537ca9d7c8e25f$export$4b62ee5120ab50a8 = /*#__PURE__*/ function() {
    "use strict";
    function MetricsCollector() {
        (0, $4GJKx._)(this, MetricsCollector);
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "resilienceMechanism", (0, $8g8TT.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
    (0, $1wc17._)(MetricsCollector, [
        {
            key: "addToItemsDiscardedByRetryCounter",
            value: function addToItemsDiscardedByRetryCounter() {
                var numberOfDeletedEvents = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.itemsDiscardedByRetry += numberOfDeletedEvents;
            }
        },
        {
            key: "addToEventCount",
            value: function addToEventCount() {
                this.eventCount++;
            }
        },
        {
            key: "addToItemsDiscardedByOverflowCounter",
            value: function addToItemsDiscardedByOverflowCounter() {
                var numberOfDeletedEvents = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
                this.itemsDiscardedByOverflow += numberOfDeletedEvents;
            }
        },
        {
            key: "setResilienceMechanism",
            value: function setResilienceMechanism(mechanism) {
                this.resilienceMechanism = mechanism;
            }
        },
        {
            /* <Localstorage specific> */ key: "addToReclaimMetrics",
            value: function addToReclaimMetrics(reclaimMetrics) {
                this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
                this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
                this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
            }
        },
        {
            key: "addToPurgedQueuesMetrics",
            value: function addToPurgedQueuesMetrics(numberOfQueuesPurged) {
                this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
            }
        },
        {
            /* </Localstorage specific> */ key: "subtractFromMetrics",
            value: function subtractFromMetrics(sentMetrics) {
                this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
                this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
                this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
                // Localstorage specific
                this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
                this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
                this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
                this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
            }
        },
        {
            key: "subtractFromCount",
            value: function subtractFromCount(count, subtract) {
                return Math.max(count - (subtract || 0), 0);
            }
        },
        {
            key: "getMetricsPayload",
            value: function getMetricsPayload() {
                return {
                    itemsDiscardedByRetry: this.itemsDiscardedByRetry,
                    eventCount: this.eventCount,
                    itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
                    resilienceMechanism: this.resilienceMechanism,
                    // Localstorage specific
                    localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
                    fullReclaims: this.localstorageNumberOfFullReclaims,
                    partialReclaims: this.localstorageNumberOfPartialReclaims,
                    failedReclaims: this.localstorageNumberOfFailedReclaims
                };
            }
        }
    ]);
    return MetricsCollector;
}();
var $31537ca9d7c8e25f$var$cachedMetricsClient = null;
var $31537ca9d7c8e25f$export$2e2bcd8739ae039 = function() {
    if (!$31537ca9d7c8e25f$var$cachedMetricsClient) $31537ca9d7c8e25f$var$cachedMetricsClient = new $31537ca9d7c8e25f$export$4b62ee5120ab50a8();
    return $31537ca9d7c8e25f$var$cachedMetricsClient;
};

});
parcelRegister("8g8TT", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", function () { return $6036b8ce5dc5dfc1$export$c75161629e3ec34e; });
$parcel$export(module.exports, "NetworkStatusEnum", function () { return $6036b8ce5dc5dfc1$export$ee138fa712d11b84; });
var $6036b8ce5dc5dfc1$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $6036b8ce5dc5dfc1$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("052TO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00f2b7766482c024$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $8g8TT = parcelRequire("8g8TT");
var $00f2b7766482c024$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function NetworkStatus(networkChangeCallback) {
        (0, $4GJKx._)(this, NetworkStatus);
        window.addEventListener("offline", function() {
            return networkChangeCallback((0, $8g8TT.NetworkStatusEnum).OFFLINE);
        });
        window.addEventListener("online", function() {
            return networkChangeCallback((0, $8g8TT.NetworkStatusEnum).ONLINE);
        });
    }
    (0, $1wc17._)(NetworkStatus, [
        {
            key: "getNetworkStatus",
            value: function getNetworkStatus() {
                if (window.navigator.onLine) return (0, $8g8TT.NetworkStatusEnum).ONLINE;
                return (0, $8g8TT.NetworkStatusEnum).OFFLINE;
            }
        }
    ]);
    return NetworkStatus;
}();

});

parcelRegister("7cLi3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53ee56432c43aaeb$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $lxwYe = parcelRequire("lxwYe");

var $cGib5 = parcelRequire("cGib5");
var $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $53ee56432c43aaeb$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
var $53ee56432c43aaeb$export$2e2bcd8739ae039 = function Scheduler(retryOptions, callback) {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, Scheduler);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "schedule", function() {
        var immediate = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            immediate: false
        }).immediate;
        if (_this.operationInFlight) {
            if (immediate) _this.queuedSchedule = $53ee56432c43aaeb$export$8bb92baee001fc60.IMMEDIATE;
            else if (_this.queuedSchedule !== $53ee56432c43aaeb$export$8bb92baee001fc60.IMMEDIATE) _this.queuedSchedule = $53ee56432c43aaeb$export$8bb92baee001fc60.WAIT;
        // Only run immediately if we have no failures
        } else if ((immediate || _this.options.waitInterval <= 0) && _this.failureCount === 0) {
            _this.clearTimeout();
            _this.run();
        // Backoff
        } else if (_this.failureCount > 0 && _this.scheduledTimeout === null) _this.scheduledTimeout = window.setTimeout(_this.run, _this.calculateBackoff());
        else if (_this.scheduledTimeout === null) _this.scheduledTimeout = window.setTimeout(_this.run, _this.options.waitInterval);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stop", function() {
        _this.clearTimeout();
        _this.queuedSchedule = $53ee56432c43aaeb$export$8bb92baee001fc60.NONE;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getFailureCount", function() {
        return _this.failureCount;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getCallbackStatus", function() {
        return _this.callbackTimer.getCallbackStatus();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clearTimeout", function() {
        if (_this.scheduledTimeout !== null) {
            window.clearTimeout(_this.scheduledTimeout);
            _this.scheduledTimeout = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "run", function() {
        _this.operationInFlight = true;
        _this.clearTimeout();
        try {
            _this.callbackTimer.executeCallbackWithTimeout(// callback to execute
            _this.callback, // when callback completes, call this function
            _this.done, // on timeout, do this instead
            function() {
                return _this.done((0, $cGib5.DoneState).ERROR);
            });
        } catch (err) {
            _this.done(err);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "done", function(state) {
        _this.operationInFlight = false;
        if (state === (0, $cGib5.DoneState).ERROR || _this.callbackTimer.getCallbackStatus() === (0, $lxwYe.CallbackStatus).TIMED_OUT) {
            _this.failureCount++;
            _this.clearTimeout();
        } else if (state === (0, $cGib5.DoneState).SUCCESS) _this.failureCount = 0;
        _this.processQueuedSchedule();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "processQueuedSchedule", function() {
        if (_this.queuedSchedule !== $53ee56432c43aaeb$export$8bb92baee001fc60.NONE) {
            var immediate = _this.queuedSchedule === $53ee56432c43aaeb$export$8bb92baee001fc60.IMMEDIATE;
            _this.queuedSchedule = $53ee56432c43aaeb$export$8bb92baee001fc60.NONE;
            _this.schedule({
                immediate: immediate
            });
        } else if (_this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
        // For example, when this.callback(this._done) was not called within
        // this.callbackTimeoutPeriod
        _this.schedule();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "calculateBackoff", function() {
        var _this_options = _this.options, minRetryDelay = _this_options.minRetryDelay, maxRetryDelay = _this_options.maxRetryDelay, backoffFactor = _this_options.backoffFactor, backoffJitterPercentage = _this_options.backoffJitterPercentage;
        var ms = minRetryDelay * Math.pow(backoffFactor, _this.failureCount);
        if (backoffJitterPercentage) {
            var rand = Math.random();
            var deviation = Math.floor(rand * backoffJitterPercentage * ms);
            if (Math.floor(rand * 10) < 5) ms -= deviation;
            else ms += deviation;
        }
        return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
    });
    this.options = {
        minRetryDelay: retryOptions.minRetryDelay || $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
        maxRetryDelay: retryOptions.maxRetryDelay || $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
        backoffFactor: retryOptions.backoffFactor || $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
        backoffJitterPercentage: retryOptions.backoffJitterPercentage || $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
        waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
        callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $53ee56432c43aaeb$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
    };
    this.scheduledTimeout = null;
    this.failureCount = 0;
    this.callback = callback;
    this.operationInFlight = false;
    this.queuedSchedule = $53ee56432c43aaeb$export$8bb92baee001fc60.NONE;
    this.callbackTimer = new (0, $lxwYe.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
};

});
parcelRegister("lxwYe", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", function () { return $fae6414b60a8a778$export$ef3353088fca369c; });
$parcel$export(module.exports, "CallbackWithTimeout", function () { return $fae6414b60a8a778$export$590a718599f8f8b3; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");
var $fae6414b60a8a778$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $fae6414b60a8a778$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
var $fae6414b60a8a778$export$590a718599f8f8b3 = /*#__PURE__*/ function() {
    "use strict";
    function CallbackWithTimeout(timeoutPeriod) {
        (0, $4GJKx._)(this, CallbackWithTimeout);
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "callbackStatus", $fae6414b60a8a778$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error("CallbackWithTimeout requires timeout period higher than 0");
    }
    (0, $1wc17._)(CallbackWithTimeout, [
        {
            // This is a state machine to control the flow of execution.
            // IDLE -> RUNNING -> COMPLETED
            // IDLE -> RUNNING -> TIMEDOUT
            key: "transitionCallbackStatus",
            value: function transitionCallbackStatus(currentStatus, event) {
                switch(currentStatus){
                    case $fae6414b60a8a778$export$ef3353088fca369c.IDLE:
                    case $fae6414b60a8a778$export$ef3353088fca369c.TIMED_OUT:
                    case $fae6414b60a8a778$export$ef3353088fca369c.COMPLETED:
                        if (event === $fae6414b60a8a778$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $fae6414b60a8a778$export$ef3353088fca369c.RUNNING;
                        break;
                    case $fae6414b60a8a778$export$ef3353088fca369c.RUNNING:
                        switch(event){
                            case $fae6414b60a8a778$export$def7d978353eaa0.COMPLETE:
                                this.callbackStatus = $fae6414b60a8a778$export$ef3353088fca369c.COMPLETED;
                                break;
                            case $fae6414b60a8a778$export$def7d978353eaa0.TIMEOUT:
                                this.callbackStatus = $fae6414b60a8a778$export$ef3353088fca369c.TIMED_OUT;
                                break;
                        }
                        break;
                    default:
                        this.callbackStatus = currentStatus;
                }
            }
        },
        {
            // Start a timeout. If this.callback(this._done) does not finish
            // by this.options.callbackTimeoutPeriod time period,
            // we will call done with a true value.
            key: "executeCallbackWithTimeout",
            value: function executeCallbackWithTimeout(callback, onDone, onTimeout) {
                var _this = this;
                this.transitionCallbackStatus(this.callbackStatus, $fae6414b60a8a778$export$def7d978353eaa0.EXECUTE);
                // Setting timeout
                this.timeoutHandle = window.setTimeout(function() {
                    _this.transitionCallbackStatus(_this.callbackStatus, $fae6414b60a8a778$export$def7d978353eaa0.TIMEOUT);
                    onTimeout();
                }, this.timeoutPeriod);
                // Executing callback
                callback(function(state) {
                    _this.cancelTimeout();
                    if (_this.getCallbackStatus() !== $fae6414b60a8a778$export$ef3353088fca369c.TIMED_OUT) {
                        _this.transitionCallbackStatus(_this.callbackStatus, $fae6414b60a8a778$export$def7d978353eaa0.COMPLETE);
                        onDone(state);
                    }
                });
            }
        },
        {
            key: "getCallbackStatus",
            value: function getCallbackStatus() {
                return this.callbackStatus;
            }
        },
        {
            // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
            // or, if the user wants to manually cancel the timeout
            key: "cancelTimeout",
            value: function cancelTimeout() {
                if (this.timeoutPeriod > 0 && this.timeoutHandle) {
                    window.clearTimeout(this.timeoutHandle);
                    this.timeoutHandle = undefined;
                }
            }
        }
    ]);
    return CallbackWithTimeout;
}();

});

parcelRegister("cGib5", function(module, exports) {

$parcel$export(module.exports, "DoneState", function () { return $93b7820154462d6a$export$f93c40fda808dd0c; });
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $93b7820154462d6a$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("445Ie", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", function () { return $2f5bf78384553587$export$c21270cab66ab290; });

var $kSuI9 = parcelRequire("kSuI9");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $7bKoC = parcelRequire("7bKoC");
function $2f5bf78384553587$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2f5bf78384553587$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2f5bf78384553587$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2f5bf78384553587$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2f5bf78384553587$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $7bKoC.SegmentEventTypes).PAGE || item.msg.type === (0, $7bKoC.SegmentEventTypes).TRACK) {
        var xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $2f5bf78384553587$var$_objectSpread($2f5bf78384553587$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $7bKoC.SegmentEventTypes).IDENTIFY) {
        var xid1 = xidCallback();
        if (xid1 && Array.isArray(xid1)) item.msg.traits = $2f5bf78384553587$var$_objectSpread($2f5bf78384553587$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid1
        });
    }
    return item;
}
function $2f5bf78384553587$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    return $2f5bf78384553587$var$_attachXidToMultipleEvents.apply(this, arguments);
}
function $2f5bf78384553587$var$_attachXidToMultipleEvents() {
    $2f5bf78384553587$var$_attachXidToMultipleEvents = (0, $kSuI9._)(function(items, xidItemPromiseCallback) {
        var xidCallback, error;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        xidItemPromiseCallback
                    ];
                case 1:
                    xidCallback = _state.sent();
                    return [
                        2,
                        items.map(function(item) {
                            return $2f5bf78384553587$export$c9c3aaf655d6f275(item, xidCallback);
                        })
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        items
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $2f5bf78384553587$var$_attachXidToMultipleEvents.apply(this, arguments);
}

});
parcelRegister("7bKoC", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", function () { return $53bd8cc7f7db7738$export$ddf929981dc6feb3; });
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
var $53bd8cc7f7db7738$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $53bd8cc7f7db7738$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $53bd8cc7f7db7738$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("alx1Y", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", function () { return $78857cc9c6a8c085$export$9175ce0e1c95daf2; });
var $78857cc9c6a8c085$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("2p4pW", function(module, exports) {

$parcel$export(module.exports, "sendEvents", function () { return $1c0157cb0c7fcf39$export$8e8f0180c1b41fad; });

var $kSuI9 = parcelRequire("kSuI9");

var $l29cN = parcelRequire("l29cN");

var $jjExS = parcelRequire("jjExS");

var $eUBSC = parcelRequire("eUBSC");
function $1c0157cb0c7fcf39$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c0157cb0c7fcf39$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c0157cb0c7fcf39$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c0157cb0c7fcf39$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1c0157cb0c7fcf39$export$8e8f0180c1b41fad = function() {
    var _ref = (0, $kSuI9._)(function(options) {
        var _createOrGetAbortCont, signal, corsOptions, response;
        return (0, $l29cN.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    signal = (_createOrGetAbortCont = $1c0157cb0c7fcf39$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
                    corsOptions = $1c0157cb0c7fcf39$var$getCorsForUrl(options.url);
                    return [
                        4,
                        fetch(options.url, $1c0157cb0c7fcf39$var$_objectSpread({
                            method: "POST",
                            // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
                            headers: {
                                "Content-Type": "text/plain"
                            },
                            body: JSON.stringify(options.batch),
                            signal: signal
                        }, corsOptions))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error("HTTP Error ".concat(response.status, " (").concat(response.statusText, ")"));
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function sendEvents(options) {
        return _ref.apply(this, arguments);
    };
}();
var $1c0157cb0c7fcf39$var$createOrGetAbortController = function(options) {
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        var abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(function() {
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
var $1c0157cb0c7fcf39$var$getCorsForUrl = (0, $eUBSC.default)(function(url) {
    var origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});

});
parcelRegister("eUBSC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adb3add65ddbc371$export$2e2bcd8739ae039; });
var $adb3add65ddbc371$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $adb3add65ddbc371$var$isEqual(first, second) {
    if (first === second) return true;
    if ($adb3add65ddbc371$var$safeIsNaN(first) && $adb3add65ddbc371$var$safeIsNaN(second)) return true;
    return false;
}
function $adb3add65ddbc371$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$adb3add65ddbc371$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $adb3add65ddbc371$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $adb3add65ddbc371$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("axYp2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7adbd72e532c3654$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $6iVV5 = parcelRequire("6iVV5");

var $ktzPa = parcelRequire("ktzPa");

var $l8E1M = parcelRequire("l8E1M");

var $bi0wG = parcelRequire("bi0wG");
var $7adbd72e532c3654$export$c28ab15bb6a6e3e7 = "ajs_anonymous_id";
// Cookie is stale, if anonymousId was generated 7 days ago.
var $7adbd72e532c3654$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
var $7adbd72e532c3654$var$SAFE = "SAFE";
var $7adbd72e532c3654$var$UNSAFE = "UNSAFE";
var $7adbd72e532c3654$var$NOT_FOUND = "NOT_FOUND";
var $7adbd72e532c3654$var$COOKIE = "COOKIE";
var $7adbd72e532c3654$var$LOCAL_STORAGE = "LOCAL_STORAGE";
var $7adbd72e532c3654$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function User() {
        (0, $4GJKx._)(this, User);
        this.store = new (0, $bi0wG.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $l8E1M.default)();
    }
    (0, $1wc17._)(User, [
        {
            key: "getUserId",
            value: function getUserId() {
                return this.userId || null;
            }
        },
        {
            key: "setUserId",
            value: function setUserId(userId) {
                this.userId = userId;
            }
        },
        {
            key: "getAnonymousId",
            value: function getAnonymousId(customAnonymousIdGenerator) {
                /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
            }
        },
        {
            key: "setAnonymousId",
            value: function setAnonymousId(anonymousId) {
                var stringifyAnonymosId = JSON.stringify(anonymousId);
                this.cookie.set($7adbd72e532c3654$export$c28ab15bb6a6e3e7, stringifyAnonymosId);
                this.lastAnonymousIdCookieUpdate = Date.now();
                return this.store.setItem($7adbd72e532c3654$export$c28ab15bb6a6e3e7, stringifyAnonymosId);
            }
        },
        {
            key: "getAnonymousIdFromStorage",
            value: function getAnonymousIdFromStorage(source) {
                var rawStorageAnonidValue = source === $7adbd72e532c3654$var$LOCAL_STORAGE ? this.store.getItem($7adbd72e532c3654$export$c28ab15bb6a6e3e7) : this.cookie.get($7adbd72e532c3654$export$c28ab15bb6a6e3e7);
                if (rawStorageAnonidValue) {
                    var unsafeValue = {
                        type: $7adbd72e532c3654$var$UNSAFE,
                        anonymousId: rawStorageAnonidValue
                    };
                    try {
                        var parsedAnonId = JSON.parse(rawStorageAnonidValue);
                        if (parsedAnonId && typeof parsedAnonId === "string") return {
                            type: $7adbd72e532c3654$var$SAFE,
                            anonymousId: parsedAnonId
                        };
                        return unsafeValue;
                    } catch (err) {
                        /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
                    }
                }
                return {
                    type: $7adbd72e532c3654$var$NOT_FOUND
                };
            }
        },
        {
            key: "getAnonymousIdFromLocalStorageAndUpdateCookieIfStale",
            value: function getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
                var localStorageValue = this.getAnonymousIdFromStorage($7adbd72e532c3654$var$LOCAL_STORAGE);
                var shouldUpdateCookie = false;
                if (!this.lastAnonymousIdCookieUpdate || (0, $6iVV5.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $7adbd72e532c3654$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
                switch(localStorageValue.type){
                    case $7adbd72e532c3654$var$SAFE:
                        if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                        return localStorageValue.anonymousId;
                    case $7adbd72e532c3654$var$UNSAFE:
                        return localStorageValue.anonymousId;
                    case $7adbd72e532c3654$var$NOT_FOUND:
                    default:
                        return null;
                }
            }
        },
        {
            key: "getAnonymousIdFromCookieAndUpdateLocalStorage",
            value: function getAnonymousIdFromCookieAndUpdateLocalStorage() {
                var cookieValue = this.getAnonymousIdFromStorage($7adbd72e532c3654$var$COOKIE);
                switch(cookieValue.type){
                    case $7adbd72e532c3654$var$SAFE:
                    case $7adbd72e532c3654$var$UNSAFE:
                        this.store.setItem($7adbd72e532c3654$export$c28ab15bb6a6e3e7, JSON.stringify(cookieValue.anonymousId));
                        return cookieValue.anonymousId;
                    case $7adbd72e532c3654$var$NOT_FOUND:
                    default:
                        return null;
                }
            }
        },
        {
            key: "generateNewAnonymousId",
            value: function generateNewAnonymousId() {
                var customAnonymousIdGenerator = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)));
                var newAnonId = customAnonymousIdGenerator();
                this.setAnonymousId(newAnonId);
                return newAnonId;
            }
        }
    ]);
    return User;
}();

});
parcelRegister("6iVV5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49715a28c806a5c0$export$2e2bcd8739ae039; });

var $bcxku = parcelRequire("bcxku");

var $9nMbt = parcelRequire("9nMbt");

var $iEgBT = parcelRequire("iEgBT");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $49715a28c806a5c0$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $49715a28c806a5c0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $iEgBT.default)(2, arguments);
    var dateLeft = (0, $bcxku.default)(dirtyDateLeft);
    var dateRight = (0, $bcxku.default)(dirtyDateRight);
    var sign = $49715a28c806a5c0$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $9nMbt.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($49715a28c806a5c0$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("bcxku", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $021ac0b28ca79ad3$export$2e2bcd8739ae039; });

var $iVDBw = parcelRequire("iVDBw");

var $iEgBT = parcelRequire("iEgBT");
function $021ac0b28ca79ad3$export$2e2bcd8739ae039(argument) {
    (0, $iEgBT.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $iVDBw.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("iVDBw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc7c4573339dd2fe$export$2e2bcd8739ae039; });
function $dc7c4573339dd2fe$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $dc7c4573339dd2fe$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dc7c4573339dd2fe$export$2e2bcd8739ae039(o);
}

});

parcelRegister("iEgBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d938d8d82288cd31$export$2e2bcd8739ae039; });
function $d938d8d82288cd31$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});


parcelRegister("9nMbt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d4ba368e8923989$export$2e2bcd8739ae039; });

var $5oghF = parcelRequire("5oghF");

var $lU1uQ = parcelRequire("lU1uQ");

var $iEgBT = parcelRequire("iEgBT");
var $6d4ba368e8923989$var$MILLISECONDS_IN_DAY = 86400000;
function $6d4ba368e8923989$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $iEgBT.default)(2, arguments);
    var startOfDayLeft = (0, $lU1uQ.default)(dirtyDateLeft);
    var startOfDayRight = (0, $lU1uQ.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $5oghF.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $5oghF.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $6d4ba368e8923989$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("5oghF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ecbd34b7d8761a1$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $3ecbd34b7d8761a1$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("lU1uQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff1ffd17d0ac1527$export$2e2bcd8739ae039; });

var $bcxku = parcelRequire("bcxku");

var $iEgBT = parcelRequire("iEgBT");
function $ff1ffd17d0ac1527$export$2e2bcd8739ae039(dirtyDate) {
    (0, $iEgBT.default)(1, arguments);
    var date = (0, $bcxku.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("l8E1M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f63964feada7957f$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");

var $jd4wD = parcelRequire("jd4wD");

var $c1ZG6 = parcelRequire("c1ZG6");

var $6ogBR = parcelRequire("6ogBR");

var $5CyIa = parcelRequire("5CyIa");
function $f63964feada7957f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f63964feada7957f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f63964feada7957f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f63964feada7957f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f63964feada7957f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function CookieWrapper() {
        (0, $4GJKx._)(this, CookieWrapper);
        this.cookieLike = (0, $5CyIa.canUseCookie)() ? (0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))) : new (0, $6ogBR.default)();
    }
    (0, $1wc17._)(CookieWrapper, [
        {
            key: "set",
            value: function set(name, value, options) {
                return this.cookieLike.set(name, value, $f63964feada7957f$var$_objectSpread($f63964feada7957f$var$_objectSpread({}, (0, $c1ZG6.COOKIE_OPTIONS)), {}, {
                    // Function is memoized so we only calculate this once per page load
                    domain: (0, $5CyIa.getTld)()
                }, options));
            }
        },
        {
            key: "get",
            value: function get(name) {
                return this.cookieLike.get(name);
            }
        },
        {
            key: "remove",
            value: function remove(name, options) {
                this.cookieLike.remove(name, $f63964feada7957f$var$_objectSpread({}, options));
            }
        }
    ]);
    return CookieWrapper;
}();

});
parcelRegister("jd4wD", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("c1ZG6", function(module, exports) {

$parcel$export(module.exports, "COOKIE_OPTIONS", function () { return $8c256bfe3ff9482c$export$5d04dceb9d38c3f8; });
var $8c256bfe3ff9482c$export$5d04dceb9d38c3f8 = {
    // 1 year
    expires: 365,
    secure: window.location.protocol === "https:",
    path: "/"
};

});

parcelRegister("6ogBR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a71de5103b2d4bd$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $bi0wG = parcelRequire("bi0wG");
var $4a71de5103b2d4bd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function LocalStorageAlt() {
        (0, $4GJKx._)(this, LocalStorageAlt);
        this.safeStorage = new (0, $bi0wG.default)({
            useStoragePrefix: false
        });
    }
    (0, $1wc17._)(LocalStorageAlt, [
        {
            key: "set",
            value: function set(name, value) {
                this.safeStorage.setItem(name, value);
                return value;
            }
        },
        {
            key: "get",
            value: function get(name) {
                var value = this.safeStorage.getItem(name);
                return value || undefined;
            }
        },
        {
            key: "remove",
            value: function remove(name) {
                this.safeStorage.removeItem(name);
            }
        }
    ]);
    return LocalStorageAlt;
}();

});
parcelRegister("bi0wG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8381c89bfb52a32b$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $cuRVC = parcelRequire("cuRVC");

var $6fntO = parcelRequire("6fntO");
var $8381c89bfb52a32b$export$2e2bcd8739ae039 = /*#__PURE__*/ function(SafeStorage) {
    "use strict";
    (0, $dcsZi._)(_class, SafeStorage);
    var _super = (0, $ohfOJ._)(_class);
    function _class(options) {
        (0, $4GJKx._)(this, _class);
        var storageToUse;
        try {
            storageToUse = window.localStorage || (0, $cuRVC.default);
        } catch (err) {
            storageToUse = (0, $cuRVC.default);
        }
        return _super.call(this, storageToUse, options);
    }
    return _class;
}((0, $6fntO.default));

});
parcelRegister("cuRVC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91921e66fc9fdc75$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");
var $91921e66fc9fdc75$export$90e3e001bcac59c7 = function InMemoryStore() {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, InMemoryStore);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_data", {});
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "length", 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setItem", function(key, value) {
        _this._data[key] = value;
        _this.length = Object.keys(_this._data).length;
        return value;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getItem", function(key) {
        if (key in _this._data) return _this._data[key];
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "removeItem", function(key) {
        if (key in _this._data) delete _this._data[key];
        _this.length = Object.keys(_this._data).length;
        return null;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clear", function() {
        _this._data = {};
        _this.length = 0;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "key", function(index) {
        return Object.keys(_this._data)[index];
    });
};
var $91921e66fc9fdc75$export$2e2bcd8739ae039 = new $91921e66fc9fdc75$export$90e3e001bcac59c7();

});

parcelRegister("6fntO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48c65b6b837fa536$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $22Iz2 = parcelRequire("22Iz2");

var $cuRVC = parcelRequire("cuRVC");
var $48c65b6b837fa536$export$41c06fdd37b7e9a5 = "awc";
var $48c65b6b837fa536$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
function $48c65b6b837fa536$export$48c17662a6902497(store) {
    var TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        var key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        var value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $48c65b6b837fa536$export$6325979d1c67607f(e) {
    var quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
var $48c65b6b837fa536$export$2e2bcd8739ae039 = function SafeStorage(storageToUse) {
    "use strict";
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _this = this;
    (0, $4GJKx._)(this, SafeStorage);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getStore", function() {
        return _this._store;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getItem", function(key) {
        return _this._store.getItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "removeItem", function(key) {
        return _this._store.removeItem(_this.createKey(key));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "setItem", function(key, value) {
        try {
            _this._store.setItem(_this.createKey(key), value);
        } catch (err) {
            if ($48c65b6b837fa536$export$6325979d1c67607f(err)) {
                _this.swapToInMemory();
                _this._store.setItem(_this.createKey(key), value);
            }
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "swapToInMemory", function() {
        if (_this._store === (0, $cuRVC.default)) return;
        var keys = Object.keys(_this._store || {});
        var inMemoryStorage;
        if ($48c65b6b837fa536$export$48c17662a6902497(window[$48c65b6b837fa536$export$770aa8bc07b3de03])) inMemoryStorage = window[$48c65b6b837fa536$export$770aa8bc07b3de03];
        else {
            inMemoryStorage = (0, $cuRVC.default);
            if (!window[$48c65b6b837fa536$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
            // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
            // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
            window[$48c65b6b837fa536$export$770aa8bc07b3de03] = (0, $cuRVC.default);
        }
        keys.forEach(function(key) {
            if (key.indexOf(_this.getPrefix()) === 0) {
                var value = _this._store.getItem(key);
                if (value) inMemoryStorage.setItem(key, value);
            }
        });
        _this._store = inMemoryStorage;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "clear", function() {
        return _this._store.clear();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "key", function(index) {
        return _this._store.key(index);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getPrefix", function() {
        return _this._prefix;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "createKey", function(key) {
        if (_this._prefix) return "".concat(_this.getPrefix(), ".").concat(key);
        return key;
    });
    this.options = options;
    var prefixes = [];
    if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($48c65b6b837fa536$export$41c06fdd37b7e9a5);
    if (options.envPrefix && options.envPrefix !== (0, $22Iz2.envType).PROD) prefixes.push(options.envPrefix);
    this._prefix = prefixes.join("-");
    if ($48c65b6b837fa536$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
    else this.swapToInMemory();
};

});



parcelRegister("5CyIa", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", function () { return $417b6d52a93286f9$export$a9330601ee8f4d95; });
$parcel$export(module.exports, "getTld", function () { return $417b6d52a93286f9$export$de6821eed3d5f32d; });

var $jd4wD = parcelRequire("jd4wD");

var $eUBSC = parcelRequire("eUBSC");
var $417b6d52a93286f9$export$a9330601ee8f4d95 = function() {
    return !(location.protocol === "file:" || location.protocol === "chrome-extension:");
};
var $417b6d52a93286f9$export$eb80e1beaa8dacf8 = "__awc_tld_test__";
var $417b6d52a93286f9$export$19164982d36535d8 = "tld_test";
var $417b6d52a93286f9$export$de6821eed3d5f32d = (0, $eUBSC.default)(function() {
    var hostname = location.hostname;
    var splitHostname = hostname.split(".");
    for(var i = 1; i <= splitHostname.length; i++){
        var domainParts = splitHostname.slice(i * -1);
        var domain = ".".concat(domainParts.join("."));
        (0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))).set($417b6d52a93286f9$export$eb80e1beaa8dacf8, $417b6d52a93286f9$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))).get($417b6d52a93286f9$export$eb80e1beaa8dacf8) === $417b6d52a93286f9$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))).remove($417b6d52a93286f9$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("il7rS", function(module, exports) {

$parcel$export(module.exports, "buildContext", function () { return $d59ff7483b8b0a90$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "prepareEventProperties", function () { return $d59ff7483b8b0a90$export$44d22e5fb02cc68e; });

var $jjExS = parcelRequire("jjExS");

var $bs4YN = parcelRequire("bs4YN");
function $d59ff7483b8b0a90$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d59ff7483b8b0a90$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d59ff7483b8b0a90$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d59ff7483b8b0a90$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d59ff7483b8b0a90$export$3a7fe28f9bf4f3d9 = function(context) {
    return $d59ff7483b8b0a90$var$_objectSpread($d59ff7483b8b0a90$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
var $d59ff7483b8b0a90$export$44d22e5fb02cc68e = function(properties) {
    var propertiesWithoutUndefined = $d59ff7483b8b0a90$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bs4YN)))(propertiesWithoutUndefined);
};
var $d59ff7483b8b0a90$export$2250ccecd1e040fd = function(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    var clone = {};
    Object.keys(obj).forEach(function(key) {
        var value = $d59ff7483b8b0a90$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map(function(i) {
                return $d59ff7483b8b0a90$export$2250ccecd1e040fd(i);
            });
            else if (typeof value === "object" && value !== null) clone[key] = $d59ff7483b8b0a90$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
var $d59ff7483b8b0a90$var$getValueOfObject = function(obj, key) {
    // @ts-ignore This is an object
    return obj[key];
};

});
parcelRegister("bs4YN", function(module, exports) {
"use strict";

var $9p8ZX = parcelRequire("9p8ZX");
/**
 * Expose `traverse`.
 */ module.exports = $85662c19eb832f0d$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $85662c19eb832f0d$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === "object") return $85662c19eb832f0d$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $85662c19eb832f0d$var$traverseArray(input, strict);
    else if ($9p8ZX.is(input, strict)) return $9p8ZX.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $85662c19eb832f0d$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $85662c19eb832f0d$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $85662c19eb832f0d$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $85662c19eb832f0d$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("9p8ZX", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $6d8d6dbd0767db55$export$98e6a39c04603d36; }, function (v) { return $6d8d6dbd0767db55$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "is", function () { return $6d8d6dbd0767db55$export$226b3eccf92c9ed9; }, function (v) { return $6d8d6dbd0767db55$export$226b3eccf92c9ed9 = v; });
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $6d8d6dbd0767db55$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $6d8d6dbd0767db55$export$226b3eccf92c9ed9;
"use strict";
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $6d8d6dbd0767db55$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$6d8d6dbd0767db55$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $6d8d6dbd0767db55$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + "00").substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === " ") offset = new Date().getTimezoneOffset();
    else if (arr[9] !== "Z" && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === "+") offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$6d8d6dbd0767db55$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== "string") return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $6d8d6dbd0767db55$var$matcher.test(string);
};

});




parcelRegister("aHFHo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cae44120b233abb$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $3sHb8 = parcelRequire("3sHb8");

var $jjExS = parcelRequire("jjExS");

var $22Iz2 = parcelRequire("22Iz2");

var $gnvfh = parcelRequire("gnvfh");
var $7cae44120b233abb$export$2e2bcd8739ae039 = function OriginTracing() {
    "use strict";
    (0, $4GJKx._)(this, OriginTracing);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "handleOriginParameters", function(originParamHandlerMapping, historyReplaceFn) {
        // Collect all the parameter labels to be handled
        var originParamLabelList = Object.keys(originParamHandlerMapping);
        if (!(originParamLabelList.length > 0)) throw new Error("Empty parameter mapping provided");
        // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
        var invalidParams = originParamLabelList.filter(function(x) {
            return Object.values((0, $22Iz2.originTracingType)).indexOf(x) < 0;
        });
        if (invalidParams.length > 0) throw new Error("Invalid Origin Tracing Parameter(s) supplied: ".concat(invalidParams.join(), "!"));
        var isCaptureParam = function(_, key) {
            return originParamLabelList.indexOf(key) >= 0;
        };
        // Capture and remove params from URL
        var capturedURLParams = (0, $gnvfh.default)(isCaptureParam, historyReplaceFn);
        // Apply provided handler function to extract origin trace ID from each URL parameter
        var applyHandlerFunction = function(key) {
            var x = originParamHandlerMapping[key](capturedURLParams[key]);
            return (0, $3sHb8._)({}, key, x);
        };
        var extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce(function(accumulator, currentValue) {
            return Object.assign(accumulator, currentValue);
        }, {});
        return extractedOriginID;
    });
    this._originStore = {};
};

});
parcelRegister("gnvfh", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", function () { return $bec707ff6befcba6$export$600dd5bf1b049f11; });
$parcel$export(module.exports, "default", function () { return $bec707ff6befcba6$export$2e2bcd8739ae039; });

var $hlOOc = parcelRequire("hlOOc");

var $9kC89 = parcelRequire("9kC89");
var $bec707ff6befcba6$export$600dd5bf1b049f11 = function(newUrl) {
    return window.history.replaceState({}, "", newUrl);
};
var $bec707ff6befcba6$var$urlParamExtractor = function(isCaptureParam) {
    var historyReplaceFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $bec707ff6befcba6$export$600dd5bf1b049f11;
    // Extract target parameters and values from URL if present
    var originalUrl = window.location.href;
    var fragmentHash = window.location.hash;
    var removedFragmentURL = fragmentHash !== "" ? originalUrl.replace(fragmentHash, "") : originalUrl;
    var _parseUrl = (0, $hlOOc.parseUrl)(removedFragmentURL), url = _parseUrl.url, query = _parseUrl.query;
    var captureParams = (0, $9kC89.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        var queryWithoutCaptureParams = (0, $9kC89.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            var newUrl = "".concat(url, "?").concat((0, $hlOOc.stringify)(queryWithoutCaptureParams)).concat(fragmentHash);
            historyReplaceFn(newUrl);
        } else historyReplaceFn("".concat(url).concat(fragmentHash));
    }
    return captureParams;
};
var $bec707ff6befcba6$export$2e2bcd8739ae039 = $bec707ff6befcba6$var$urlParamExtractor;

});
parcelRegister("hlOOc", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $ca1bcf611781a0b5$export$f9380c9a627682d3; }, function (v) { return $ca1bcf611781a0b5$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $ca1bcf611781a0b5$export$98e6a39c04603d36; }, function (v) { return $ca1bcf611781a0b5$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $ca1bcf611781a0b5$export$fac44ee5b035f737; }, function (v) { return $ca1bcf611781a0b5$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $ca1bcf611781a0b5$export$7a5253c0f62e0150; }, function (v) { return $ca1bcf611781a0b5$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $ca1bcf611781a0b5$export$a8c1621ea79325d3; }, function (v) { return $ca1bcf611781a0b5$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $ca1bcf611781a0b5$export$357523c63a2253b9; }, function (v) { return $ca1bcf611781a0b5$export$357523c63a2253b9 = v; });

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");
var $ca1bcf611781a0b5$export$f9380c9a627682d3;
var $ca1bcf611781a0b5$export$98e6a39c04603d36;
var $ca1bcf611781a0b5$export$fac44ee5b035f737;
var $ca1bcf611781a0b5$export$7a5253c0f62e0150;
var $ca1bcf611781a0b5$export$a8c1621ea79325d3;
var $ca1bcf611781a0b5$export$357523c63a2253b9;
var $ca1bcf611781a0b5$export$44c361b8ec72ef7f;
"use strict";

var $6pUpV = parcelRequire("6pUpV");

var $zKeTC = parcelRequire("zKeTC");

var $ljZAm = parcelRequire("ljZAm");

var $2Mx4x = parcelRequire("2Mx4x");
var $ca1bcf611781a0b5$var$isNullOrUndefined = function(value) {
    return value === null || value === undefined;
};
var $ca1bcf611781a0b5$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $ca1bcf611781a0b5$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return function(key) {
                return function(result, value) {
                    var index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            "[",
                            $ca1bcf611781a0b5$var$encode(index, options),
                            "]=",
                            $ca1bcf611781a0b5$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "bracket":
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            "[]"
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            "[]=",
                            $ca1bcf611781a0b5$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "colon-list-separator":
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            ":list="
                        ].join("")
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            ":list=",
                            $ca1bcf611781a0b5$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                var keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return function(key) {
                    return function(result, value) {
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $ca1bcf611781a0b5$var$encode(key, options),
                                keyValueSep,
                                $ca1bcf611781a0b5$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $ca1bcf611781a0b5$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
                };
            }
        default:
            return function(key) {
                return function(result, value) {
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return (0, $c6Xmf._)(result).concat([
                        $ca1bcf611781a0b5$var$encode(key, options)
                    ]);
                    return (0, $c6Xmf._)(result).concat([
                        [
                            $ca1bcf611781a0b5$var$encode(key, options),
                            "=",
                            $ca1bcf611781a0b5$var$encode(value, options)
                        ].join("")
                    ]);
                };
            };
    }
}
function $ca1bcf611781a0b5$var$parserForArrayFormat(options) {
    var result;
    switch(options.arrayFormat){
        case "index":
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return function(key, value, accumulator) {
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return function(key, value, accumulator) {
                var isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                var isEncodedArray = typeof value === "string" && !isArray && $ca1bcf611781a0b5$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $ca1bcf611781a0b5$var$decode(value, options) : value;
                var newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(function(item) {
                    return $ca1bcf611781a0b5$var$decode(item, options);
                }) : value === null ? value : $ca1bcf611781a0b5$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return function(key, value, accumulator) {
                var isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $ca1bcf611781a0b5$var$decode(value, options) : value;
                    return;
                }
                var arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map(function(item) {
                    return $ca1bcf611781a0b5$var$decode(item, options);
                });
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $ca1bcf611781a0b5$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $ca1bcf611781a0b5$var$encode(value, options) {
    if (options.encode) return options.strict ? $6pUpV(value) : encodeURIComponent(value);
    return value;
}
function $ca1bcf611781a0b5$var$decode(value, options) {
    if (options.decode) return $zKeTC(value);
    return value;
}
function $ca1bcf611781a0b5$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $ca1bcf611781a0b5$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $ca1bcf611781a0b5$var$removeHash(input) {
    var hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $ca1bcf611781a0b5$var$getHash(url) {
    var hash = "";
    var hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $ca1bcf611781a0b5$var$extract(input) {
    input = $ca1bcf611781a0b5$var$removeHash(input);
    var queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $ca1bcf611781a0b5$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $ca1bcf611781a0b5$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $ca1bcf611781a0b5$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    var formatter = $ca1bcf611781a0b5$var$parserForArrayFormat(options);
    // Create an object with no prototype
    var ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = query.split("&")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var param = _step.value;
            if (param === "") continue;
            var _splitOnFirst = (0, $cv9Rk._)($ljZAm(options.decode ? param.replace(/\+/g, " ") : param, "="), 2), key = _splitOnFirst[0], value = _splitOnFirst[1];
            // Missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            value = value === undefined ? null : [
                "comma",
                "separator",
                "bracket-separator"
            ].includes(options.arrayFormat) ? value : $ca1bcf611781a0b5$var$decode(value, options);
            formatter($ca1bcf611781a0b5$var$decode(key, options), value, ret);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.keys(ret)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var key1 = _step1.value;
            var value1 = ret[key1];
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            if (typeof value1 === "object" && value1 !== null) try {
                for(var _iterator2 = Object.keys(value1)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var k = _step2.value;
                    value1[k] = $ca1bcf611781a0b5$var$parseValue(value1[k], options);
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            else ret[key1] = $ca1bcf611781a0b5$var$parseValue(value1, options);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce(function(result, key) {
        var value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $ca1bcf611781a0b5$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$ca1bcf611781a0b5$export$f9380c9a627682d3 = $ca1bcf611781a0b5$var$extract;
$ca1bcf611781a0b5$export$98e6a39c04603d36 = $ca1bcf611781a0b5$var$parse;
$ca1bcf611781a0b5$export$fac44ee5b035f737 = function(object, options) {
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $ca1bcf611781a0b5$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    var shouldFilter = function(key) {
        return options.skipNull && $ca1bcf611781a0b5$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    };
    var formatter = $ca1bcf611781a0b5$var$encoderForArrayFormat(options);
    var objectCopy = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(object)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!shouldFilter(key)) objectCopy[key] = object[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map(function(key) {
        var value = object[key];
        if (value === undefined) return "";
        if (value === null) return $ca1bcf611781a0b5$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $ca1bcf611781a0b5$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $ca1bcf611781a0b5$var$encode(key, options) + "=" + $ca1bcf611781a0b5$var$encode(value, options);
    }).filter(function(x) {
        return x.length > 0;
    }).join("&");
};
$ca1bcf611781a0b5$export$7a5253c0f62e0150 = function(url, options) {
    options = Object.assign({
        decode: true
    }, options);
    var _splitOnFirst = (0, $cv9Rk._)($ljZAm(url, "#"), 2), url_ = _splitOnFirst[0], hash = _splitOnFirst[1];
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $ca1bcf611781a0b5$var$parse($ca1bcf611781a0b5$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $ca1bcf611781a0b5$var$decode(hash, options)
    } : {});
};
$ca1bcf611781a0b5$export$a8c1621ea79325d3 = function(object, options) {
    options = Object.assign((0, $3sHb8._)({
        encode: true,
        strict: true
    }, $ca1bcf611781a0b5$var$encodeFragmentIdentifier, true), options);
    var url = $ca1bcf611781a0b5$var$removeHash(object.url).split("?")[0] || "";
    var queryFromUrl = $ca1bcf611781a0b5$export$f9380c9a627682d3(object.url);
    var parsedQueryFromUrl = $ca1bcf611781a0b5$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    var query = Object.assign(parsedQueryFromUrl, object.query);
    var queryString = $ca1bcf611781a0b5$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = "?".concat(queryString);
    var hash = $ca1bcf611781a0b5$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = "#".concat(options[$ca1bcf611781a0b5$var$encodeFragmentIdentifier] ? $ca1bcf611781a0b5$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier);
    return "".concat(url).concat(queryString).concat(hash);
};
$ca1bcf611781a0b5$export$357523c63a2253b9 = function(input, filter, options) {
    options = Object.assign((0, $3sHb8._)({
        parseFragmentIdentifier: true
    }, $ca1bcf611781a0b5$var$encodeFragmentIdentifier, false), options);
    var _exports_parseUrl = $ca1bcf611781a0b5$export$7a5253c0f62e0150(input, options), url = _exports_parseUrl.url, query = _exports_parseUrl.query, fragmentIdentifier = _exports_parseUrl.fragmentIdentifier;
    return $ca1bcf611781a0b5$export$a8c1621ea79325d3({
        url: url,
        query: $2Mx4x(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$ca1bcf611781a0b5$export$44c361b8ec72ef7f = function(input, filter, options) {
    var exclusionFilter = Array.isArray(filter) ? function(key) {
        return !filter.includes(key);
    } : function(key, value) {
        return !filter(key, value);
    };
    return $ca1bcf611781a0b5$export$357523c63a2253b9(input, exclusionFilter, options);
};

});



parcelRegister("jzYVM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4108ccbf8871302$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");

var $bi0wG = parcelRequire("bi0wG");
var $e4108ccbf8871302$var$SESSION_ID_STORAGE_KEY = "session.id";
var $e4108ccbf8871302$var$SESSION_EXPIRY_STORAGE_KEY = "session.expiry";
var $e4108ccbf8871302$var$ONLY_NUMBERS_REGEX = /^\d+$/;
var $e4108ccbf8871302$export$285f6bddd927a06d = 1800000; // 30 minutes
var $e4108ccbf8871302$export$a92e915d70316eb2 = 5000; // 5 seconds
var $e4108ccbf8871302$export$de43760b2dc10c19 = 0.9; // 90% of expiry
var $e4108ccbf8871302$export$5702a91a6f42969f = function() {};
var $e4108ccbf8871302$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function SessionTracking() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var _this = this;
        (0, $4GJKx._)(this, SessionTracking);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_generateNewSessionId", function() {
            var newSessionId = Date.now().toString();
            _this._safeLocalStorage.setItem($e4108ccbf8871302$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            _this._onNewSessionStarted && _this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_updateSessionExpiry", function() {
            var expiry = Date.now() + _this._sessionExpiryTime;
            _this._safeLocalStorage.setItem($e4108ccbf8871302$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_debouncedUpdateSessionExpiry", function(currentExpiry) {
            var _updateSessionExpiry = _this._updateSessionExpiry;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + _this._sessionExpiryDebounceThresholdPercentage * _this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (_this._sessionExpiryDebounceTimer) clearTimeout(_this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                _this._sessionExpiryDebounceTimer = setTimeout(function() {
                    _updateSessionExpiry();
                }, _this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $e4108ccbf8871302$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $e4108ccbf8871302$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $e4108ccbf8871302$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $e4108ccbf8871302$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $bi0wG.default)();
    }
    (0, $1wc17._)(SessionTracking, [
        {
            key: "getCurrentSessionId",
            value: function getCurrentSessionId() {
                var sessionId = this._safeLocalStorage.getItem($e4108ccbf8871302$var$SESSION_ID_STORAGE_KEY);
                var sessionExpiry = parseInt(this._safeLocalStorage.getItem($e4108ccbf8871302$var$SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
                this._debouncedUpdateSessionExpiry(sessionExpiry);
                if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
                // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
                // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
                if (!$e4108ccbf8871302$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
                return sessionId;
            }
        }
    ]);
    return SessionTracking;
}();

});

parcelRegister("kTmBT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f35a7b96abdfaa29$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $dcsZi = parcelRequire("dcsZi");

var $ohfOJ = parcelRequire("ohfOJ");

var $cuRVC = parcelRequire("cuRVC");

var $6fntO = parcelRequire("6fntO");
var $f35a7b96abdfaa29$export$2e2bcd8739ae039 = /*#__PURE__*/ function(SafeStorage) {
    "use strict";
    (0, $dcsZi._)(_class, SafeStorage);
    var _super = (0, $ohfOJ._)(_class);
    function _class(options) {
        (0, $4GJKx._)(this, _class);
        var storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $cuRVC.default);
        } catch (err) {
            storageToUse = (0, $cuRVC.default);
        }
        return _super.call(this, storageToUse, options);
    }
    return _class;
}((0, $6fntO.default));

});

parcelRegister("f6Y6c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b00608f1176bf709$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $jjExS = parcelRequire("jjExS");

var $ktzPa = parcelRequire("ktzPa");

var $kTmBT = parcelRequire("kTmBT");
var $b00608f1176bf709$var$STORAGE_KEY = "tab.id";
var $b00608f1176bf709$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function TabTracking() {
        var _this = this;
        (0, $4GJKx._)(this, TabTracking);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_generateNewTabId", function() {
            var newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))();
            _this._safeSessionStorage.setItem($b00608f1176bf709$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $kTmBT.default)();
    }
    (0, $1wc17._)(TabTracking, [
        {
            key: "getCurrentTabId",
            value: function getCurrentTabId() {
                var tabId = this._safeSessionStorage.getItem($b00608f1176bf709$var$STORAGE_KEY);
                if (!tabId) tabId = this._generateNewTabId();
                return tabId;
            }
        }
    ]);
    return TabTracking;
}();

});

parcelRegister("1kGnl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f888792aac1cc2f$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $hlOOc = parcelRequire("hlOOc");

var $ktzPa = parcelRequire("ktzPa");

var $22Iz2 = parcelRequire("22Iz2");

var $9kC89 = parcelRequire("9kC89");

var $kTmBT = parcelRequire("kTmBT");

var $gnvfh = parcelRequire("gnvfh");
function $0f888792aac1cc2f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0f888792aac1cc2f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0f888792aac1cc2f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0f888792aac1cc2f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0f888792aac1cc2f$var$STORAGE_KEY = "taskSessions";
var $0f888792aac1cc2f$var$INIT_KEY = "taskSessionsInit";
var $0f888792aac1cc2f$var$AWC_PARAM_PREFIX = "awc.";
var $0f888792aac1cc2f$var$TASK_SESSION_RELOAD_TIME = 3000;
var $0f888792aac1cc2f$export$2e2bcd8739ae039 = function TaskSessionStore() {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, TaskSessionStore);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_taskSessionsNotRecentlyInitialised", function(currentTimestamp) {
        return _this._safeSessionStorage.getItem($0f888792aac1cc2f$var$STORAGE_KEY) === null || _this._safeSessionStorage.getItem($0f888792aac1cc2f$var$INIT_KEY) === null || parseInt(_this._safeSessionStorage.getItem($0f888792aac1cc2f$var$INIT_KEY) || "0", 10) < currentTimestamp - $0f888792aac1cc2f$var$TASK_SESSION_RELOAD_TIME;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_removeTaskSessionPrefix", function(_, taskSessionName) {
        return taskSessionName.split($0f888792aac1cc2f$var$AWC_PARAM_PREFIX)[1];
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_isTaskSessionQueryParam", function(_, taskSessionName) {
        return taskSessionName.startsWith($0f888792aac1cc2f$var$AWC_PARAM_PREFIX);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "getAllTaskSessions", function() {
        try {
            return JSON.parse(_this._safeSessionStorage.getItem($0f888792aac1cc2f$var$STORAGE_KEY) || "");
        } catch (e) {
            return {};
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_writeToSessionStorage", function(taskSessions) {
        try {
            _this._safeSessionStorage.setItem($0f888792aac1cc2f$var$STORAGE_KEY, JSON.stringify(taskSessions));
        // eslint-disable-next-line no-empty
        } catch (e) {}
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_appendTaskSessions", function(newTaskSessions) {
        var currentState = _this.getAllTaskSessions();
        var newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
        _this._writeToSessionStorage(newState);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_safelyRemoveKey", function(currentState, taskSessionName) {
        if (currentState === null) return {};
        delete currentState[taskSessionName];
        return currentState;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "createTaskSession", function(taskSessionName) {
        var taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($ktzPa)))();
        var newTaskSessions = {};
        newTaskSessions[taskSessionName] = taskSessionId;
        _this._appendTaskSessions(newTaskSessions);
        return taskSessionId;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "createTaskSessionWithProvidedId", function(taskSessionName, taskSessionId) {
        if (typeof taskSessionId !== "string") throw new TypeError("invalid taskSessionId, must be string");
        var newTaskSessions = {};
        newTaskSessions[taskSessionName] = taskSessionId;
        _this._appendTaskSessions(newTaskSessions);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "completeTaskSession", function(taskSessionName) {
        var currentState = _this.getAllTaskSessions();
        var updatedState = _this._safelyRemoveKey(currentState, taskSessionName);
        _this._writeToSessionStorage(updatedState);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "formatTaskSessionQueryString", function(param) {
        var uri = param.uri, includedTaskSessions = param.includedTaskSessions;
        var _parseUrl = (0, $hlOOc.parseUrl)(uri), url = _parseUrl.url, query = _parseUrl.query;
        var currentState = _this.getAllTaskSessions();
        // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
        var filteredTaskSessions = includedTaskSessions ? (0, $9kC89.pick)(currentState, includedTaskSessions) : (0, $9kC89.omit)(currentState, Object.values((0, $22Iz2.originTracingType)));
        if (Object.keys(filteredTaskSessions).length === 0) return uri;
        var queryWithTaskSessions = $0f888792aac1cc2f$var$_objectSpread($0f888792aac1cc2f$var$_objectSpread({}, (0, $9kC89.mapKeys)(filteredTaskSessions, function(_, taskSessionName) {
            return $0f888792aac1cc2f$var$AWC_PARAM_PREFIX + taskSessionName;
        })), query);
        return "".concat(url, "?").concat((0, $hlOOc.stringify)(queryWithTaskSessions));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stripQueryParameters", function() {
        var extractedTaskSessions = (0, $9kC89.mapKeys)((0, $gnvfh.default)(_this._isTaskSessionQueryParam), _this._removeTaskSessionPrefix);
        _this._appendTaskSessions(extractedTaskSessions);
    });
    var _currentTimestamp = Date.now();
    this._safeSessionStorage = new (0, $kTmBT.default)();
    // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
    try {
        if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
            this._writeToSessionStorage({});
            this._safeSessionStorage.setItem($0f888792aac1cc2f$var$INIT_KEY, _currentTimestamp.toString());
        }
    // eslint-disable-next-line no-empty
    } catch (e) {}
};

});

parcelRegister("6f3e8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48b6a59e4cdd697f$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $jjExS = parcelRequire("jjExS");

var $jd4wD = parcelRequire("jd4wD");
var $48b6a59e4cdd697f$var$MAX_CACHE_SIZE = 100;
var $48b6a59e4cdd697f$var$COOKIE_NAME = "atlassian_analytics_debug";
var $48b6a59e4cdd697f$var$DEBUG_TAG = "synthetic";
var $48b6a59e4cdd697f$var$getDebugCookie = function() {
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))).get($48b6a59e4cdd697f$var$COOKIE_NAME) || "false");
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($jd4wD))).remove($48b6a59e4cdd697f$var$COOKIE_NAME);
    }
    return false;
};
var $48b6a59e4cdd697f$var$TestingCache = function TestingCache() {
    "use strict";
    var _this = this;
    (0, $4GJKx._)(this, TestingCache);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_bind", function() {
        if (window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: function() {
                return window.testAnalytics.eventCache;
            },
            clear: function() {
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem("awc.ui.viewed.last.sent");
                    localStorage.removeItem("awc-staging.ui.viewed.last.sent");
                    localStorage.removeItem("awc-dev.ui.viewed.last.sent");
                    localStorage.removeItem("awc-local.ui.viewed.last.sent");
                } catch (_error) {
                // Ignore errors from localStorage.
                }
            }
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_cache", function(event) {
        if (window.testAnalytics.eventCache.length >= $48b6a59e4cdd697f$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_shouldCacheEvent", function() {
        return _this._isDebugCookieEnabled;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "saveEvent", function(event) {
        if (event && _this._shouldCacheEvent()) {
            if (!window.testAnalytics) _this._bind();
            if (event.tags instanceof Array) event.tags.push($48b6a59e4cdd697f$var$DEBUG_TAG);
            else event.tags = [
                $48b6a59e4cdd697f$var$DEBUG_TAG
            ];
            _this._cache(event);
        }
    });
    this._isDebugCookieEnabled = $48b6a59e4cdd697f$var$getDebugCookie();
    if (this._isDebugCookieEnabled) this._bind();
};
var $48b6a59e4cdd697f$export$2e2bcd8739ae039 = $48b6a59e4cdd697f$var$TestingCache;

});

parcelRegister("bJ204", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $889572dbea124ca2$export$2e2bcd8739ae039; });

var $4GJKx = parcelRequire("4GJKx");

var $04Kcc = parcelRequire("04Kcc");

var $jjExS = parcelRequire("jjExS");

var $22Iz2 = parcelRequire("22Iz2");

var $bi0wG = parcelRequire("bi0wG");
var $889572dbea124ca2$var$_excluded = [
    "embeddedProduct"
];
function $889572dbea124ca2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $889572dbea124ca2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $889572dbea124ca2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $889572dbea124ca2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $889572dbea124ca2$var$DEFAULT_DELAY = 2000; // 2 seconds
var $889572dbea124ca2$var$DEFAULT_THROTTLE = 3600000; // 1 hour
var $889572dbea124ca2$var$DEFAULT_STORAGE_KEY = "ui.viewed.last.sent";
var $889572dbea124ca2$export$2e2bcd8739ae039 = function UIViewedEvent(productInfo, getContext, onEvent) {
    "use strict";
    var settings = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var _this = this;
    (0, $4GJKx._)(this, UIViewedEvent);
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "start", function() {
        _this._startInterval();
        _this._bindEventListeners();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "stop", function() {
        _this._stopInterval();
        _this._unbindEventListeners();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "resetTimers", function() {
        if (_this._intervalId) {
            _this.stop();
            _this.start();
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_bindEventListeners", function() {
        window.addEventListener("focus", _this._focusListener);
        window.addEventListener("blur", _this._blurListener);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_unbindEventListeners", function() {
        window.removeEventListener("focus", _this._focusListener);
        window.removeEventListener("blur", _this._blurListener);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_startInterval", function() {
        clearInterval(_this._intervalId);
        _this._intervalId = setInterval(_this._handleInterval, _this._delay);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_stopInterval", function() {
        if (_this._intervalId) {
            clearInterval(_this._intervalId);
            _this._intervalId = null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getProductKey", function(product, subproduct) {
        var productKey = product;
        if (subproduct) productKey += "-".concat(subproduct);
        return productKey;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_getLastSentTimestamp", function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData() || {};
        var u = json[userId] || {};
        var t = u[tenantId] || {};
        var p = t[productKey] || null;
        return p;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_parseLocalStorageData", function() {
        var data = _this._safeLocalStorage.getItem(_this._storageKey);
        try {
            return JSON.parse(data || "");
        } catch (error) {
            _this._safeLocalStorage.removeItem(_this._storageKey);
            return null;
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_setLastSentTimestamp", function(productKey, tenantId, userId) {
        var json = _this._parseLocalStorageData() || {};
        var u = json[userId] || {};
        var t = u[tenantId] || {};
        t[productKey] = Date.now();
        u[tenantId] = t;
        json[userId] = u;
        _this._safeLocalStorage.setItem(_this._storageKey, JSON.stringify(json));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_shouldSendEvent", function(productKey, tenantIdType, tenantId, userId) {
        if (!document.hasFocus()) return false;
        if (tenantIdType !== (0, $22Iz2.tenantType).NONE && !tenantId || !userId) return false;
        var sinceLastSent = Date.now() - _this._getLastSentTimestamp(productKey, tenantId, userId);
        return sinceLastSent > _this._throttle;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_handleInterval", function() {
        var _this$_getContext = _this._getContext(), embeddedProduct = _this$_getContext.embeddedProduct, context = (0, (/*@__PURE__*/$parcel$interopDefault($04Kcc)))(_this$_getContext, $889572dbea124ca2$var$_excluded);
        _this._sendEvent(_this._product, context);
        if (embeddedProduct) _this._sendEvent(embeddedProduct, context, true);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_sendEvent", function(product, context) {
        var isEmbeddedProduct = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        var subproduct = context.subproduct, tenantIdType = context.tenantIdType, tenantId = context.tenantId, userId = context.userId, lastScreenEvent = context.lastScreenEvent, attributes = context.attributes;
        var productKey = _this._getProductKey(product, subproduct);
        if (_this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
            _this._setLastSentTimestamp(productKey, tenantId, userId);
            var event = _this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
            _this._onEvent(event);
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(this, "_createEvent", function(product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes) {
        var event = {
            product: product,
            source: "ui",
            action: "viewed",
            actionSubject: "ui",
            attributes: extraAttributes
        };
        if (isEmbeddedProduct) {
            // Clear the subproduct and version as they don't relate to the embedded product
            event.subproduct = null;
            event.version = null;
            event.attributes = $889572dbea124ca2$var$_objectSpread($889572dbea124ca2$var$_objectSpread({}, event.attributes), {}, {
                embeddedInEnv: _this._productInfo.env,
                embeddedInProduct: _this._productInfo.product,
                embeddedInSubproduct: subproduct,
                embeddedInVersion: _this._productInfo.version,
                embeddedInOrigin: _this._productInfo.origin,
                embeddedInPlatform: _this._productInfo.platform
            });
        }
        if (lastScreenEvent) event.attributes = $889572dbea124ca2$var$_objectSpread($889572dbea124ca2$var$_objectSpread({}, event.attributes), {}, {
            lastScreenEvent: {
                name: lastScreenEvent.name,
                attributes: lastScreenEvent.attributes
            }
        });
        return event;
    });
    if (!productInfo) throw new Error("Missing productInfo");
    if (!productInfo.product) throw new Error("Missing productInfo.product");
    if (!getContext) throw new Error("Missing getContext callback");
    if (typeof getContext !== "function") throw new Error("Invalid getContext, must be function");
    if (!onEvent) throw new Error("Missing onEvent callback");
    if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
    this._productInfo = productInfo;
    this._product = productInfo.product;
    this._getContext = getContext;
    this._onEvent = onEvent;
    this._delay = settings.delay || $889572dbea124ca2$var$DEFAULT_DELAY;
    this._throttle = settings.throttle || $889572dbea124ca2$var$DEFAULT_THROTTLE;
    this._storageKey = settings.storageKey || $889572dbea124ca2$var$DEFAULT_STORAGE_KEY;
    this._safeLocalStorage = new (0, $bi0wG.default)({
        envPrefix: this._productInfo.env
    });
    this._focusListener = function() {
        _this._startInterval();
    };
    this._blurListener = function() {
        _this._stopInterval();
    };
};

});

parcelRegister("5LQZZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $433a7401582f41b5$export$2e2bcd8739ae039; });
function $433a7401582f41b5$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== "function") return null;
    return function() {
        callback(event);
    };
}

});

parcelRegister("29bQh", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", function () { return $19059bae2a00d13f$export$fbe53bbbe682bcdd; });

var $5bFr4 = parcelRequire("5bFr4");
var $19059bae2a00d13f$export$fbe53bbbe682bcdd = function(xidConsent, xidPromiseFn) {
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === "function") {
        var timeoutPromise = function() {
            return new Promise(function(resolve) {
                setTimeout(function() {
                    return resolve(function() {
                        return (0, $5bFr4.createTimeoutXid)();
                    });
                }, (0, $5bFr4.XID_TIMEOUT));
            });
        };
        var xidPromise = function() {
            return xidPromiseFn().catch(function() {
                return function() {
                    return (0, $5bFr4.createUnknownXid)();
                };
            });
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("5bFr4", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", function () { return $3c6e1f12ca380016$export$545bcbd53afabfa3; });
$parcel$export(module.exports, "createTimeoutXid", function () { return $3c6e1f12ca380016$export$af4087e36d63846; });
$parcel$export(module.exports, "createUnknownXid", function () { return $3c6e1f12ca380016$export$fa341d0c750d705b; });

var $8uyVA = parcelRequire("8uyVA");
var $3c6e1f12ca380016$export$545bcbd53afabfa3 = 5000;
var $3c6e1f12ca380016$export$af4087e36d63846 = function() {
    return [
        {
            type: (0, $8uyVA.XIDItemType).XC,
            state: "TIMEOUT"
        },
        {
            type: (0, $8uyVA.XIDItemType).UID,
            state: "TIMEOUT"
        }
    ];
};
var $3c6e1f12ca380016$export$fa341d0c750d705b = function() {
    return [
        {
            type: (0, $8uyVA.XIDItemType).XC,
            state: "UNKNOWN"
        },
        {
            type: (0, $8uyVA.XIDItemType).UID,
            state: "UNKNOWN"
        }
    ];
};

});
parcelRegister("8uyVA", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", function () { return $62ec38028996f397$export$92ca0438bcb0d396; });
var $62ec38028996f397$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $62ec38028996f397$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});





})();
//# sourceMappingURL=esm.2ca81a2e.js.map
